// Copyright (c) 2016 Deere & Company

export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "Uk\u0142ad o tej nazwie ju\u017C istnieje",
  ACCEPT: "Akceptuj",
  ACCEPT_ALL: "Zaakceptuj wszystko",
  ACCEPT_REJECT_TRANSFER_PENDING: "Zatwierdzenie",
  ACCEPTED: "Zaakceptowano",
  ACCOUNT: "Konto",
  ACCOUNT_ADDRESS: "Adres konta",
  ACCOUNT_COUNTRY: "Kraj przypisany do konta",
  ACCOUNT_END: "Koniec konta",
  ACCOUNT_NAME: "Nazwa konta",
  ACCOUNT_NUMBER: "Numer konta",
  ACCOUNT_NUMBER_REQUIRED: "Wymagany jest numer konta",
  ACCOUNTS: "Konta",
  ACCUMULATED_DAYS_ON_RENT: "Suma dni wynajmu",
  ACCUMULATED_DAYS_RENTED: "Suma dni wypo\u017Cyczenia",
  ACTIONS: "Dzia\u0142ania",
  ACTIVE_WARRANTY: "Aktywna gwarancja",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "Wa\u017Cna gwarancja (kliknij, aby uzyska\u0107 szczeg\xF3\u0142y)",
  ACTUAL_AUDIT: "Rzeczywisty audyt",
  ACTUAL_AUDIT_DATE: "Rzeczywista data audytu",
  ACTUAL_COURIER_NAME: "Aktualna nazwa przewo\u017Anika",
  ACTUAL_HOURS: "Aktualne godziny",
  ADD_CLAIM: "Dodaj roszczenie",
  ADD_CLAIMS: "Dodaj roszczenia",
  ADD_COMPONENT: "Dodaj komponent",
  ADD_OPTION: "Dodaj opcje",
  ADD_REP: "Dodatkowa naprawa",
  ADD_TO_AUDIT: "Dodaj do audytu",
  ADDITIONAL: "Dodatkowy",
  ADDITIONAL_COMMENTS: "Uwagi dodatkowe",
  ADDITIONAL_REPAIR: "Dodatkowa naprawa",
  ADDITIVE: "Dodatek",
  ADDRESS: "Adres",
  ADDRESS_LINE1: "Wiersz adresu 1",
  ADDRESS_LINE1_REQUIRED: "Wymagany wiersz adresu 1",
  ADDRESS_LINE2: "Wiersz adresu 2",
  ADJ_CLM: "Dostosuj roszczenie",
  ADJUST_CLAIM: "Dostosuj roszczenie",
  ADJUSTED_HOURS: "Liczba godzin",
  ADJUSTED_QUANTITY: "Dostosowana ilo\u015B\u0107",
  ADJUSTMENT_TYPE: "Typ regulacji",
  ADVANCED_CLAIM_SUMMARY: "Zaawansowane Podsumowanie reklamacji",
  AFTER_DELIVERY_INSPECTION: "KONTROLA PO DOSTAWIE",
  AGENCY_NAME: "Nazwa agencji",
  ALL: "Wszystko",
  ALL_ACCOUNTS: "Wszystkie konta",
  ALL_CLAIMS: "Wszystkie reklamacje",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "Wszystkie reklamacje podlegaj\u0105 przegl\u0105dowi (patrz JD WAM 110.08 w celu uzyskania dalszych informacji)",
  ALL_CLAIMS_TAB: "Wszystkie roszczenia ({count, number})",
  ALL_PART_REQUESTS: "Wszystkie wnioski o cz\u0119\u015Bci",
  ALL_PART_REQUESTS_WITH_COUNT: "Wszystkie wnioski o cz\u0119\u015Bci ({count})",
  ALL_PARTS_RETURNED: "Zwr\xF3cono wszystkie cz\u0119\u015Bci",
  AMOUNT: "Ilo\u015B\u0107",
  AMOUNT_1: "Ilo\u015B\u0107 1",
  AMOUNT_2: "Ilo\u015B\u0107 2",
  AMOUNT_3: "Ilo\u015B\u0107 3",
  AMOUNT_OF_USE: "Czas U\u017Cytkowania",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "Historia czasu wykorzystania ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "Wymagane jest podanie czasu u\u017Cytkowania",
  AMOUNT_OF_USE_REQUIRED: "Wymagany czas u\u017Cytkowania",
  AMOUNT_OF_USE_UNITS_REQUIRED: "Wymagane jednostki czasu u\u017Cytkowania",
  AMOUNT_RECORDED: "Zapisano czas",
  AMOUNT_TO_BE_DEBITED: "Kwota do obci\u0105\u017Cenia",
  APLYPIP: "Zastosuj PIP",
  APPLICATION: "Zastosowanie",
  APPLICATION_IS_REQUIRED: "Wymagane jest podanie zastosowania",
  APPLY: "Zastosuj",
  APPLY_TRAVEL: "Dostosuj podr\xF3\u017C",
  APPROVAL_DEALER_COMMENTS: "Uwagi dealera zatwierdzaj\u0105cego",
  APPROVAL_DETAILS: "Szczeg\xF3\u0142y zatwierdzenia",
  APPROVAL_LEVELS: "Poziom zatwierdzenia",
  APPROVAL_REMARKS: "Uwagi dotycz\u0105ce zatwierdzenia",
  APPROVAL_STATUS: "Stan zatwierdzenia",
  APPROVE: "Zatwierd\u017A",
  APPROVE_LABOR_RATE: "Zatwierdzona stawka robocza",
  APPROVE_MACHINE_STATUS_UPDATE: "Zatwierd\u017A aktualizacj\u0119 stanu maszyny",
  APPROVE_PIP_CODE_REQUEST: "Zatwierd\u017A wniosek o kod PIP",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "Zatwierd\u017A roszczenie dotycz\u0105ce przydzia\u0142u specjalnego",
  APPROVED: "ZATWIERDZONO",
  APPROVED_CORE_VALUE: "Zatwierdzona warto\u015B\u0107 Core",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "Data zatwierdzenia nie mo\u017Ce by\u0107 wcze\u015Bniejsza ni\u017C data ustawienia",
  APPROVED_DIAGNOSTIC_AMOUNT: "Zatwierdzona kwota diagnostyczna",
  APPROVED_DIAGNOSTIC_HOURS: "Zatwierdzone godziny diagnostyczne",
  APPROVED_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola zatwierdzenia",
  APPROVED_LABOR_ADDITIVE: "Zatwierdzony koszt pracy",
  APPROVED_LABOR_AMOUNT: "Zatwierdzona warto\u015B\u0107 pracy",
  APPROVED_LABOR_HOURS: "Zatwierdzone godziny pracy",
  APPROVED_LABOR_TOTAL: "Ca\u0142kowita liczba zaakceptowanej pracy",
  APPROVED_ON_SHELF_COST: "Zatwierdzone dla koszt\xF3w magazynowania",
  APPROVED_OTHER_CREDITS: "Zatwierdzone inne kredyty",
  APPROVED_PARTS: "Zatwierdzone cz\u0119\u015Bci",
  APPROVED_PARTS_ADDITIVE: "Zatwierdzony koszt dodatkowy cz\u0119\u015Bci",
  APPROVED_PARTS_TOTAL: "Ca\u0142kowita liczba zaakceptowanych cz\u0119\u015Bci",
  APPROVED_REJECTED: "Zatwierdzono/odrzucono",
  APPROVED_REPAIR_AMOUNT: "Zatwierdzona kwota naprawy",
  APPROVED_REPAIR_HOURS: "Zatwierdzone godziny naprawy",
  APPROVED_TAXES_TOTAL: "Ca\u0142kowita suma zatwierdzonych obci\u0105\u017Ce\u0144 podatkowych",
  APPROVED_TRAVEL_TOTAL: "Ca\u0142kowita liczba zaakceptowanych podr\xF3\u017Cy",
  APPROVER: "Osoba zatwierdzaj\u0105ca",
  ASCENDING: "kolejno\u015Bci rosn\u0105cej",
  ATTACHMENTS: "Za\u0142\u0105czniki",
  AUDIT_NUMBER: "Numer audytu",
  AUDIT_PLANNED: "Planowany audyt",
  AUDIT_REQUIREMENT: "Wym\xF3g audytu",
  AUDIT_RESULTS: "Rezultaty audytu",
  AUDIT_STATUS: "Status audytu",
  AUDIT_SUBMITTED_SUCCESSFULLY: "Audyt zosta\u0142 pomy\u015Blnie przes\u0142any",
  AUDIT_SUMMARY: "Podsumowanie audytu",
  AUDIT_TYPE: "Typ audytu",
  AUDITS: "Audyty",
  AUDITS_DUE_WITH_COUNT: "Liczba zbli\u017Caj\u0105cych si\u0119 audyt\xF3w {countToDisplay}",
  AUDITS_DUE_WITHIN_30_DAYS: "W ci\u0105gu najbli\u017Cszych 30 dni odb\u0119dzie si\u0119 nast\u0119puj\u0105ca liczba audyt\xF3w {countToDisplay} {count, plural, one {audyt} other {audyt\xF3w}}",
  AUDITS_PAST_DUE_WITH_COUNT: "Liczba audyt\xF3w po terminie {countToDisplay} {count, plural, one {audyt} other {audyt\xF3w}}",
  AUTHORIZATION_NUMBER: "Numer autoryzacji",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "Automatycznie wy\u015Blij z biznesowego systemu dealer\xF3w",
  AVAILABLE: "DOST\u0118PNE",
  AVAILABLE_COLUMNS: "Dost\u0119pne Kolumny",
  AVERAGE_DIAGNOSTICS_HOURS: "\u015Arednia liczba godzin diagnostycznych",
  AVERAGE_LUG_HEIGHT: "\u015Arednia wysoko\u015B\u0107 uchwytu",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "Wymagana jest \u015Brednia wysoko\u015B\u0107 uchwytu",
  AVERAGE_REPAIR_HOURS: "\u015Arednia liczba godzin naprawy",
  AVERAGE_REPLACEMENT_HOURS: "\u015Arednia liczba godzin wymiany",
  AVERAGE_TECH_PAY_RATE: "\u015Arednia stawka robocza pracownik\xF3w technicznych",
  BACK: "Wstecz",
  BACK_TO_AUDIT: "Powr\xF3t do audytu",
  BASE_MACHINE: "Podstawowa maszyna",
  BASE_MACHINE_IMPLEMENTS: "Sprz\u0119t maszyny podstawowej",
  BASE_MACHINE_PIN: "PIN maszyny podstawowej",
  BASIC_WARRANTY_ENDS: "Koniec podstawowej gwarancji",
  BASIC_WARRANTY_ESTIMATOR: "Podstawowy estymator gwarancji",
  BASIC_WARRANTY_STARTS: "Pocz\u0105tek podstawowej gwarancji",
  BASIS_FOR_SETTLEMENT: "Podstawa do rozliczenia",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "Podstawa do rozliczenia / Uwagi do audytu",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "Wymagana jest podstawa do rozliczenia",
  BATTERY: "BATERIA",
  BEGIN_DATE: "Data pocz\u0105tkowa",
  BRANCH: "Oddzia\u0142",
  BUILT: "Skonstruowano",
  BUSINESS_END: "Zako\u0144czenie dzia\u0142alno\u015Bci",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "Czy maszyna mo\u017Ce zosta\u0107 ponownie uruchomiona?",
  CANCEL: "Anuluj",
  CERTIFIED_LETTER_SENT: "Wys\u0142ano list potwierdzony",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "Zmie\u0144 odpowiedzialnego dealera",
  CHANGE_STATUS: "Zmie\u0144 stan",
  CHANGE_STATUS_FOR: "Zmie\u0144 status na {pin}",
  CHANGED: "Zmieniony",
  CHANGED_BY: "Zmienione przez",
  CHANGED_ON: "Zmieniane w",
  CHINESE: "Chi\u0144ski",
  CITY: "Miasto",
  CITY_REQUIRED: "Wymagane miasto",
  CLAIM: "Roszczenie",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {Roszczenie} other {Roszczenie}})",
  CLAIM_DEBIT: "Obci\u0105\u017Cenie roszczenia",
  CLAIM_DETAILS: "Szczeg\xF3\u0142y reklamacji",
  CLAIM_DRAFT: "WERSJA ROBOCZA",
  CLAIM_HISTORY: "24 miesi\u0119czna historia \u017C\u0105dania",
  CLAIM_HISTORY_WITH_COUNT: "24 miesi\u0119czna historia \u017C\u0105dania ({count})",
  CLAIM_NUMBER: "Numer reklamacji",
  CLAIM_RECOVER_PERCENTAGE: "({percentage}%)",
  CLAIM_SEARCH: "Wyszukiwanie reklamacji",
  CLAIM_STATUS: "Status roszczenia",
  CLAIM_TYPE: "Rodzaj reklamacji",
  CLAIM_TYPES: "Rodzaje roszcze\u0144",
  CLAIM_UPDATED_SUCCESSFULLY: "Roszczenie zaktualizowano pomy\u015Blnie",
  CLAIM_VALUE: "Warto\u015B\u0107 reklamacji",
  CLAIM_VALUE_DETAILS: "Szczeg\xF3\u0142y dotycz\u0105ce warto\u015Bci roszczenia",
  CLAIM_WITH_NUMBER: "Roszczenie {claimNumber}",
  CLAIMS: "Reklamacje",
  CLAIMS_IN_PROGRESS: "Roszczenia w toku",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "Roszczenia w toku ({count})",
  CLAIMS_OVERVIEW: "Podsumowanie roszcze\u0144",
  CLAIMS_OVERVIEW_TAB: "Podsumowanie roszcze\u0144 ({count})",
  CLAIMS_WITH_COUNT: "Liczba roszcze\u0144 {count}",
  CLICK_FOR_DETAILS: "(Kliknij, aby wy\u015Bwietli\u0107 szczeg\xF3\u0142y)",
  CLICK_TO_VIEW_ALL: "Kliknij, aby wy\u015Bwietli\u0107 wszystko",
  CLOSE: "Zamknij",
  CLOSED_PART_REQUESTS: "Zamkni\u0119te \u017C\u0105dania cz\u0119\u015Bci",
  CLOSING: "Zako\u0144czenie",
  CLOSING_ACCOUNT: "Konto ko\u0144cowe",
  CLOSING_ACCOUNT_WITH_COUNT: "Konto ko\u0144cowe ({count})",
  CODE: "Kod",
  COLLAPSE_ALL: "Zwi\u0144 wszystko",
  COMMENT: "Uwaga",
  COMMENTS: "Uwagi",
  COMMENTS_IS_REQUIRED: "Wymagane s\u0105 komentarze",
  COMMENTS_TO_DEALER: "Komentarze dla dealera",
  COMMON_LABOR_TYPES_WARNING: "Nie wszystkie rodzaje pracy dost\u0119pne dla wybranych kont",
  COMPANY: "Firma",
  COMPANY_CONTRIBUTION: "Wk\u0142ad firmy",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "Wymagane jest podanie wk\u0142adu firmy",
  COMPLAINT_CAUSE: "Jaki by\u0142 pow\xF3d reklamacji?",
  COMPLAINT_CAUSE_IS_REQUIRED: "Wymagany jest pow\xF3d reklamacji",
  COMPLAINT_CORRECTION: "W jaki spos\xF3b zosta\u0142a rozpatrzona reklamacja?",
  COMPLAINT_CORRECTION_IS_REQUIRED: "Wymagany jest spos\xF3b rozpatrzenia reklamacji",
  COMPLETE: "Zako\u0144czone",
  COMPLETED: "Uko\u0144czono",
  COMPLETED_BY: "Uzupe\u0142niony przez",
  COMPLETED_DATE: "Data uko\u0144czenia",
  COMPLETED_IN_LAST_24_MONTHS: "Uko\u0144czone w ci\u0105gu ostatnich 24 miesi\u0119cy",
  COMPLETION_STATUS: "Status uko\u0144czenia",
  COMPONENT: "Podzesp\xF3\u0142",
  COMPONENT_CODE: "Kod komponentu",
  COMPONENT_CREATED_SUCCESSFULLY: "Komponent stworzony pomy\u015Blnie",
  COMPONENT_DELETED_SUCCESSFULLY: "Komponent usuni\u0119ty pomy\u015Blnie",
  COMPONENT_SERIAL_NUMBER: "Numer seryjny komponentu",
  COMPONENT_SUCCESSFULLY_UPDATED: "Podzesp\xF3\u0142 zaktualizowany pomy\u015Blnie",
  COMPONENTS: "Komponenty",
  CONFIRM: "Potwierd\u017A",
  CONFIRM_ADDITIONAL_REPAIR: "Czy na pewno chcesz doda\u0107 dodatkow\u0105 napraw\u0119?",
  CONFIRM_ADJUST_CLAIM: "Czy na pewno chcesz dostosowa\u0107 to roszczenie?",
  CONFIRM_CLOSING_ACCOUNT: "Czy na pewno chcesz zaakceptowa\u0107 to przeniesienie?",
  CONFIRM_COPY_CLAIM: "Czy na pewno chcesz skopiowa\u0107 to roszczenie?",
  CONFIRM_DELETE_ATTACHMENT: "Czy na pewno chcesz usun\u0105\u0107 za\u0142\u0105czony plik?",
  CONFIRM_DELETE_CLAIM: "Czy na pewno chcesz usun\u0105\u0107 to roszczenie?",
  CONFIRM_DELETE_REGISTRATION: "Czy na pewno chcesz usun\u0105\u0107 t\u0119 rejestracj\u0119?",
  CONFIRM_EDIT_CLAIM: "Czy na pewno chcesz edytowa\u0107 to roszczenie?",
  CONFIRM_RECONCILE_CLAIM: "Czy na pewno chcesz uzgodni\u0107 to roszczenie?",
  CONFIRM_RESEND_XML: "Czy na pewno chcesz ponownie wys\u0142a\u0107 plik XML? Nale\u017Cy odczeka\u0107 24-48 godzin, a\u017C b\u0119dzie widoczny.",
  CONFIRM_SKIP_AUDIT: "Czy na pewno chcesz pomin\u0105\u0107 ten audyt?",
  CONFIRM_UNDO_REGISTRATION: "Czy na pewno chcesz cofn\u0105\u0107 t\u0119 rejestracj\u0119?",
  CONTACTED: "Skontaktowano",
  CONTAINS: "Zawiera",
  CONTRACT_NUMBER: "Numer umowy",
  CONTRACT_PURCHASED: "Zawarta umowa",
  CONTRACT_TYPE: "Rodzaj umowy",
  COPY_CLAIM: "Kopiuj reklamacj\u0119",
  CORE: "Podstawa",
  CORE_VALUE: "Najwa\u017Cniejsza warto\u015B\u0107",
  COUNTRY: "Kraj",
  COUNTRY_REQUIRED: "Wymagany kraj",
  COURIER_ACCOUNT_NUMBER: "Numer konta przewo\u017Anika",
  COURIER_NAME: "Nazwa przewo\u017Anika",
  COVERAGE_DECISION: "Decyzja w sprawie pokrycia",
  COVERAGE_TYPE: "Typ pokrycia",
  CRDMEM: "Faktura koryguj\u0105ca",
  CREATE: "Utw\xF3rz",
  CREATE_CLAIM: "Utw\xF3rz reklamacj\u0119",
  CREATE_LAYOUT: "Utw\xF3rz Uk\u0142ad",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "Przed z\u0142o\u017Ceniem roszczenia dotycz\u0105cego tego produktu przeka\u017C nam kilka istotnych informacji",
  CREATE_PIP_CLAIM: "Utw\xF3rz roszczenie PIP",
  CREATE_PIP_CLAIMS: "Utw\xF3rz roszczenia PIP",
  CREATE_PRODUCT_RECORD: "Utw\xF3rz wpis w rejestrze dotycz\u0105cy produktu",
  CREATE_REQUEST: "Utw\xF3rz \u017C\u0105danie",
  CREATE_TRANSFER_PENDING: "Transfer w toku",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "Funkcja utworzenia us\u0142ugi transferu niedost\u0119pna",
  CREATED: "Utworzono",
  CREATED_BY: "Utworzony przez",
  CREATED_DATE: "Data utworzenia",
  CREATED_ON: "Utworzono",
  CREATION_DATE: "Data utworzenia",
  CREDIT_MEMO: "Nota kredytowa",
  CREDIT_MEMO_DATE: "Data noty kredytowej",
  CREDIT_MEMO_ISSUE_DATE: "Wydanie faktury koryguj\u0105cej",
  CREDIT_MEMO_NUMBER: "Numer faktury koryguj\u0105cej",
  CREDIT_MEMO_PROCESS_DATE: "Przetwarzanie faktury koryguj\u0105cej",
  CREDIT_MEMO_SELECTED: "Wybrana nota kredytowa",
  CREDIT_MEMOS: "Noty kredytowa",
  CRITERIA: "Kryteria",
  CRT: "Utw\xF3rz",
  CSV_SEPARATOR: "Separator CSV",
  CURRENCY: "Waluta",
  CURRENT: "Aktualny",
  CURRENT_ACCOUNT: "Aktualne konto",
  CURRENT_AMOUNT_OF_USE: "Aktualny Czas U\u017Cytkowania",
  CURRENT_CUSTOMER: "Bie\u017C\u0105cy klient",
  CURRENT_DEALER: "Obecny dealer",
  CURRENT_DEALER_DISTANCE: "Bie\u017C\u0105ca odleg\u0142o\u015B\u0107 dealera",
  CURRENT_DEALER_LAST_SERVICE_DATE: "Bie\u017C\u0105ca data ostatniej us\u0142ugi dla dealera",
  CURRENT_DEALER_LOCATION: "Obecny client",
  CURRENT_HOURS: "Bie\u017C\u0105ce godziny",
  CURRENT_QUANTITY: "Bie\u017C\u0105ca ilo\u015B\u0107",
  CURRENT_RESPONSIBLE_DEALER: "Bie\u017C\u0105cy odpowiedzialny sprzedawca",
  CURRENT_VALUES: "Bie\u017C\u0105ce warto\u015Bci",
  CURRENTLY_ON_RENT: "Obecnie wynaj\u0119te",
  CUSTOM_RANGE: "Zakres niestandardowy",
  CUSTOM_VALUES: "Warto\u015Bci klienta",
  CUSTOMER: "Klient",
  CUSTOMER_CONTRIBUTION: "Wk\u0142ad klienta",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "Wymagane jest podanie wk\u0142adu klienta",
  CUSTOMER_CREATED_SUCCESSFULLY: "Pomy\u015Blnie utworzono profil klienta",
  CUSTOMER_DETAILS: "Dane klienta",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "Pomy\u015Blnie zaktualizowano szczeg\xF3\u0142y dotycz\u0105ce klienta",
  CUSTOMER_INFORMATION: "Informacje dla klient\xF3w",
  CUSTOMER_INFORMATION_IS_REQUIRED: "Wymagane s\u0105 informacje o klientach.",
  CUSTOMER_INVALID: "Nieprawid\u0142owy klient",
  CUSTOMER_NAME: "Nazwa klienta",
  CUSTOMER_NAME_IS_REQUIRED: "Wymagane s\u0105 informacje o klientach.",
  CUSTOMER_NOT_FOUND: "Nie znaleziono klienta",
  CUSTOMER_REQUIRED: "Klient wymagany",
  CUSTOMER_RESOLUTION: "Rozwi\u0105zanie dla klienta",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "Wymagane jest podanie rozwi\u0105zania dla klienta",
  CUSTOMER_SEARCH: "Wyszukiwanie klienta",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Pomy\u015Blnie zaktualizowano profil klienta",
  DAMAGED_MACHINES_HELP_TEXT: "W przypadku uszkodzonych maszyn gwarancja zostanie automatycznie zawieszona do czasu przejrzenia i zatwierdzenia niniejszego formularza przez technika TCSM w celu przywr\xF3cenia gwarancji. Uszkodzone maszyny kwalifikuj\u0105 si\u0119 wy\u0142\u0105cznie do obowi\u0105zkowych PIP i zabezpiecze\u0144.",
  DATE: "Data",
  DATE_FORMAT: "Format daty",
  DATE_ISSUED: "Data wydania",
  DATE_OF_CERTIFIED_LETTER: "Data nadania listu potwierdzonego",
  DATE_OF_EVENT_CAUSING_DAMAGE: "Data zdarzenia powoduj\u0105cego szkod\u0119",
  DATE_OF_LAST_PERSONAL_CONTACT: "Data ostatniego kontaktu osobistego",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "Data transportu/wys\u0142ania wspomnianej cz\u0119\u015Bci",
  DATE_REFUSED: "Data odrzucona",
  DATE_SUBMITTED: "Data przes\u0142ania",
  DAYS_FROM_REGISTRATION: "Liczba dni od rejestracji",
  DAYS_LEFT: "Pozosta\u0142e dni",
  DAYS_LEFT_WITH_COUNT: "{daysToDisplay} {days, plural, one {dzie\u0144} other {dni}}",
  DAYS_ON_RENT: "Dni wynaj\u0119cia",
  DAYS_REMAINING: "Pozosta\u0142o dni",
  DAYS_REMAINING_WITH_COUNT: "Pozosta\u0142o {daysToDisplay} {days, plural, one {dzie\u0144} other {dni}}",
  DAYS_TO_DISPLAY: "Liczba dni do wy\u015Bwietlenia",
  DBS: "DBS",
  DEALER: "Dealer",
  DEALER_ACCOUNT: "Konto dealera",
  DEALER_ACCOUNT_IS_REQUIRED: "Wymagane jest podanie konta dealera",
  DEALER_ACCOUNTS: "Konta dealera",
  DEALER_CITY: "Miasto dealera",
  DEALER_COMMENTS: "Uwagi dealera",
  DEALER_CONTRIBUTION: "Wk\u0142ad dealera",
  DEALER_CONTRIBUTION_IS_REQUIRED: "Wymagane jest podanie wk\u0142adu dealera",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({industryIndicator})",
  DEALER_INVOICE_NUMBER: "Numer faktury dla dealera",
  DEALER_INVOICE_UPDATED: "FAKTURA PRZEDSTAWICIELA ZAKTUALIZOWANA",
  DEALER_INVOICE_UPDATES: "Faktura dealera",
  DEALER_INVOICES: "Faktury dealera",
  DEALER_LOCATION: "Lokalizacja dealera",
  DEALER_LOCATION_FILTER: "Filtruj lokalizacje",
  DEALER_LOCATION_IS_REQUIRED: "Wymagana jest lokalizacja dealera",
  DEALER_LOCATIONS: "Lokalizacje dealer\xF3w",
  DEALER_NAME: "Nazwa dealera",
  DEALER_PHONE: "Nr telefonu dealera",
  DEALER_POSTAL_CODE: "Kod pocztowy",
  DEALER_RECOMMENDATIONS: "Zalecenia dla dealer\xF3w",
  DEALER_RECOMMENDATIONS_TAB: "Zalecenia dla dealer\xF3w ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "Sprzedawca zosta\u0142 pomy\u015Blnie przejrzany",
  DEALER_SEARCH: "Wyszukiwanie dealera",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "Aby wyszuka\u0107 dealer\xF3w, wpisz nazw\u0119 miasta lub konta",
  DEALER_STATE: "Stan deleara/prowincja",
  DEALER_SUBMISSION_WITH_CURRENCY: "Warto\u015B\u0107 zg\u0142oszenia do dealera ({currency})",
  DEALER_TRANSFER_HISTORY: "Historia przeniesienia dealera",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "\u017B\u0105danie transferu dealera zosta\u0142o pomy\u015Blnie umieszczone w kolejce",
  DEALER_WARRANTY: "Gwarancja dealera",
  DEALERS: "Dealerzy",
  DEALERSHIP: "Salon dealerski",
  DEBIT: "Obci\u0105\u017Cenie",
  DEBIT_AMOUNT: "Kwota obci\u0105\u017Cenia",
  DEBIT_FOR_CLAIM_NUMBER: "Obci\u0105\u017Cenie roszczenia {claimNumber}",
  DEBIT_REQUIRED: "\u017B\u0105danie obci\u0105\u017Cenia",
  DEBIT_REQUIRED_STATUS: "Status wymaganego obci\u0105\u017Cenia",
  DEBIT_SUBMITTED_SUCCESSFULLY: "Warto\u015B\u0107 obci\u0105\u017Cenia zosta\u0142a przes\u0142ana",
  DEBIT_TYPE: "Typ debetu",
  DEBITED: "Spieni\u0119\u017Cone",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "Obci\u0105\u017Cenie niniejszego roszczenia musi by\u0107 uko\u0144czone poprzez r\u0119czne przetwarzanie obci\u0105\u017Cenia",
  DECIMAL_FORMAT: "Format dziesi\u0119tny",
  DECISION_UPDATED: "Decyzja zaktualizowana",
  DECLINE: "Odrzu\u0107",
  DEDUCTIBLE: "Kwota potr\u0105cona",
  DEERE_REMARKS: "Uwagi Deere",
  DEFAULT_WARRANTY: "Gwarancja domy\u015Blna",
  DEL: "Usu\u0144",
  DELETE: "Usu\u0144",
  DELETE_ATTACHMENT: "Usu\u0144 za\u0142\u0105cznik",
  DELETE_CLAIM: "Usu\u0144 roszczenie",
  DELETE_REGISTRATION: "Usu\u0144 rejestracj\u0119",
  DELETE_REGISTRATION_SUCCESS: "Usuni\u0119cie rejestracji powiod\u0142o si\u0119",
  DELETED: "USUNI\u0118TO",
  DELETED_BY: "Ununi\u0119to przez",
  DELIVERED: "Dostarczono",
  DELIVERED_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola dostarczenia",
  DELIVERY_DATE: "Data dostawy",
  DELIVERY_DATE_REQUIRED: "Wymagana data dostawy",
  DELIVERY_DATES: "Daty dostaw",
  DELIVERY_NO_DOCUMENTS: "Dostawa bez dokument\xF3w",
  DEMO_RENTAL_BEGIN_DATE: "Data rozpocz\u0119cia wynajmu pr\xF3bnego/wynajmu",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "Wybierz status i dealer\xF3w",
  DEMO_RENTAL_END_DATE: "Data zako\u0144czenia wynajmu pr\xF3bnego/wynajmu",
  DEMO_RENTAL_HISTORY: "Historia wynajmu pr\xF3bnego",
  DENY: "Odrzu\u0107",
  DENY_MACHINE_STATUS_UPDATE: "Odrzu\u0107 aktualizacj\u0119 stanu maszyny",
  DENY_PIP_CODE_REQUEST: "Odrzu\u0107 wniosek o kod PIP",
  DESCENDING: "kolejno\u015Bci malej\u0105cej",
  DESCRIPTION: "opis",
  DESCRIPTION_OF_DAMAGE: "Opis uszkodzenia",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "Opis zdarzenia powoduj\u0105cego uszkodzenie",
  DESELECT_ALL: "Odznacz wszystko",
  DETAILS: "Szczeg\xF3\u0142y",
  DIAGNOSTICS_COVERED: "Diagnostyka w zakresie",
  DIS_VSR: "Wy\u015Bwietlane wiadomo\u015Bci",
  DISPLAY: "Wy\u015Bwietl",
  DISPLAY_CLAIM: "Wy\u015Bwietl reklamacj\u0119",
  DISPLAY_CREDIT_MEMO: "Wy\u015Bwietl not\u0119 kredytow\u0105",
  DISPLAY_FORMAT: "Format wy\u015Bwietlania",
  DISPLAY_PRODUCT: "Wy\u015Bwietl Produkt",
  DISPLAY_TAG: "Wy\u015Bwietl znacznik",
  DISTANCE: "Odleg\u0142o\u015B\u0107",
  DISTANCE_FROM_CURRENT_DEALER: "Odleg\u0142o\u015B\u0107 od bie\u017C\u0105cego sprzedawcy",
  DISTANCE_FROM_POTENTIAL_DEALER: "Odleg\u0142o\u015B\u0107 od potencjalnego sprzedawcy",
  DIVISION: "Dzia\u0142",
  DIVISION_SUMMARY: "Podsumowanie dzia\u0142u",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "Czy chcesz zapisa\u0107 zmiany?",
  DOES_NOT_CONTAIN: "Nie zawiera",
  DOWNLOAD_TO_EXCEL: "Pobierz do programu Excel",
  DOWNTIME: "Czas przestoj\xF3w",
  DOWNTIME_IS_REQUIRED: "Wymagany jest przest\xF3j",
  DRAFT: "Zapisz w wersjach roboczych",
  DTAC_CASE: "Sprawa DTAC",
  DTAC_CASE_NUMBER: "Numer przypadku DTAC",
  DTAC_SOLUTION: "Rozwi\u0105zanie DTAC",
  DUE_DATE: "Termin realizacji",
  DUE_WITHIN_3_MONTHS: "Realizacja w ci\u0105gu 3 miesi\u0119cy",
  DUPLICATE_PIN_PLATE: "Zduplikowana tabliczka z numerem PIN",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "Zaktualizowano \u017C\u0105danie zduplikowanej tabliczki z numerem PIN",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "Pomy\u015Blnie utworzono \u017C\u0105danie zduplikowanej tabliczki z numerem PIN",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "Zduplikowane \u017C\u0105danie tabliczki z numerem PIN ({count})",
  EDIT: "Edytuj",
  EDIT_CUSTOMER: "Edytuj klienta",
  EDIT_LAYOUT: "Edytuj Uk\u0142ad",
  EDIT_WITH_PARENTHESES: "(Edytuj)",
  EFFECTIVE: "Efektywno\u015B\u0107",
  EFFECTIVE_DATE: "Data wej\u015Bcia w \u017Cycie",
  EMAIL: "E-mail",
  EMISSIONS_PART_SEARCH: "Wyszukiwanie cz\u0119\u015Bci uk\u0142adu wydechowego",
  END_DATE: "Data ko\u0144cowa",
  END_USE: "U\u017Cytkowanie ko\u0144cowe",
  END_USE_CODE: "Kod u\u017Cytkowania ko\u0144cowego",
  END_USE_CODE_REQUIRED: "Wymagany kod u\u017Cytkowania ko\u0144cowego",
  ENDS_WITH: "Ko\u0144czy si\u0119 na",
  ENGLISH: "Angielski",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "Wpisz liczb\u0119 z przedzia\u0142u 0\u20131000",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "Wprowad\u017A liczb\u0119 z zakresu od 0 do 10000",
  ENTER_A_NUMBER_FROM_1_TO_9999: "Wpisz liczb\u0119 1\u20139999",
  ENTER_A_PART_NUMBER: "Wprowad\u017A numer cz\u0119\u015Bci",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "Wpisz komentarz przed kontynuowaniem",
  EQUALS: "R\xF3wna si\u0119",
  ERROR: "B\u0141\u0104D",
  ERROR_MESSAGE_TITLE: "Wyst\u0105pi\u0142 b\u0142\u0105d",
  ERROR_MESSAGES: "Komunikaty o b\u0142\u0119dach",
  ERROR_MESSAGES_TITLE: "Wyst\u0105pi\u0142y b\u0142\u0119dy",
  ERROR_NETWORK_ISSUES: "B\u0142\u0105d sieci uniemo\u017Cliwi\u0142 wczytanie niekt\xF3rych danych \u2014 spr\xF3buj ponownie",
  ERROR_NO_DATA_TO_EXPORT: "Brak danych do wyeksportowania",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "B\u0142\u0105d podczas pobierania informacji o odbiorcy",
  ERROR_SAP: "Brak mo\u017Cliwo\u015Bci po\u0142\u0105czenia z serwerem. Je\u015Bli problem b\u0119dzie si\u0119 powtarza\u0142, wybierz \u0142\u0105cze \u201ESkontaktuj si\u0119 z nami\u201D, aby uzyska\u0107 pomoc przy rozwi\u0105zywaniu problemu.",
  ERROR_SESSION: "Sesja wygas\u0142a. Od\u015Bwie\u017C stron\u0119, aby powt\xF3rnie si\u0119 zalogowa\u0107.",
  ERROR_UNHANDLED: "Nieoczekiwany b\u0142\u0105d systemu. Je\u015Bli problem b\u0119dzie si\u0119 powtarza\u0142, skorzystaj z funkcji \u201EPomoc\u201D lub wybierz \u0142\u0105cze \u201ESkontaktuj si\u0119 z nami\u201D, aby uzyska\u0107 pomoc przy rozwi\u0105zywaniu problemu.",
  ERROR_UPLOADING_FILE: "Plik nie zosta\u0142 dodany",
  ESTIMATED_BASIC_DATE: "Przewidywana data podstawowa",
  ESTIMATED_BASIC_DAYS: "Przewidywana liczba dni bazowych",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "Szacunki mog\u0105 nie uwzgl\u0119dnia\u0107 stanu demo lub godzin jeszcze niezg\u0142oszonych",
  EXCEEDS_DEMO_THRESHOLD: "Przekracza pr\xF3g dla demonstracji",
  EXCHANGE_RATE: "Kurs walut",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "Wy\u0142\u0105czone numery PIN nie s\u0105 uwzgl\u0119dnione w tym raporcie.",
  EXECUTE: "Wykonaj",
  EXPAND_ALL: "Rozwi\u0144 wszystko",
  EXPECTED_FIRST_USE: "Przewidywane pierwsze u\u017Cytkowanie",
  EXPIRATION_DATE: "Data wa\u017Cno\u015Bci",
  EXPIRED: "Wygas\u0142",
  EXPIRED_PART_REQUESTS: "Wygas\u0142e \u017C\u0105dania cz\u0119\u015Bci",
  EXPIRED_PIPS: "Przedawnione PIP",
  EXPIRES: "Up\u0142ywa",
  EXPIRING_SOON: "Nied\u0142ugo wyga\u015Bnie",
  EXPORT: "Eksportuj",
  EXTENDED_WARRANTY: "Rozszerzona gwarancja",
  FACTORY: "FABRYKA",
  FACTORY_NAME: "Nazwa fabryki",
  FAILED: "Usterka",
  FAILED_AREA: "Obszar wyst\u0105pienia usterki",
  FAILED_AREA_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola usterki",
  FAILED_DATE: "Data usterki",
  FAILED_DATE_IS_REQUIRED: "Wymagane jest podanie daty usterki",
  FAILED_MODE: "Tryb awaryjny",
  FAILED_MODE_COMMENTS: "Uwagi do trybu awaryjnego",
  FAILED_PART: "Uszkodzona cz\u0119\u015B\u0107",
  FAILED_PART_DESCRIPTION: "Opis uszkodzonej cz\u0119\u015Bci",
  FAILED_PART_IS_A_REMAN_PART: "Niepowodzenie Cz\u0119\u015B\u0107 jest cz\u0119\u015Bci\u0105 ReMan",
  FAILED_PART_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola \u201EUszkodzona cz\u0119\u015B\u0107\u201D",
  FAILED_PART_SERIAL: "Numer seryjny uszkodzonej cz\u0119\u015Bci",
  FAILED_PART_SERIAL_IS_REQUIRED: "Wymagany jest numer seryjny uszkodzonej cz\u0119\u015Bci",
  FAILURE_DATE: "Data awarii",
  FAILURE_INFORMATION: "Informacje o awarii",
  FAILURE_MODE: "Tryb awarii",
  FAILURE_MODE_IS_REQUIRED: "Wymagane jest podanie trybu usterki",
  FAILURE_PART: "Uszkodzona cz\u0119\u015B\u0107",
  FAILURE_PART_DESCRIPTION: "Opis uszkodzonej cz\u0119\u015Bci",
  FAILURE_PART_IS_REQUIRED: "Wymagana jest uszkodzona cz\u0119\u015B\u0107.",
  FAILURE_TO_RETURN_PARTS_WARNING: "Brak zwrotu \u017C\u0105danych cz\u0119\u015Bci mo\u017Ce spowodowa\u0107 obci\u0105\u017Cenie rachunku.",
  FAVORITES: "Ulubiony",
  FILE_NAME: "Nazwa pliku",
  FILE_SIZE_IS_TOO_BIG: "Rozmiar pliku jest zbyt du\u017Cy (maksymalny rozmiar 10 MB)",
  FILE_SIZE_IS_TOO_BIG_CSV: "Rozmiar pliku jest zbyt du\u017Cy (maksymalny rozmiar 1 MB)",
  FILE_UPLOAD_MESSAGE: "Upu\u015B\u0107 pliki tutaj lub kliknij, aby je doda\u0107 (maksymalny rozmiar 10 MB)",
  FILE_UPLOAD_MESSAGE_CSV: "Upu\u015B\u0107 pliki tutaj lub kliknij, aby je doda\u0107 (maksymalny rozmiar 1 MB)",
  FILE_UPLOAD_MESSAGE_IMAGE: "Upu\u015B\u0107 obrazy tutaj lub kliknij, aby je doda\u0107 (maksymalny rozmiar 10 MB).",
  FILE_UPLOAD_MESSAGE_SINGLE: "Upu\u015B\u0107 tutaj pojedynczy plik lub kliknij, aby doda\u0107 (maksymalny rozmiar 10 MB)",
  FILE_UPLOAD_UNABLE_TO_READ: "System nie m\xF3g\u0142 odczyta\u0107 pliku.  Por\xF3wnaj go z szablonem i spr\xF3buj ponownie.",
  FILES: "Pliki",
  FILTER_PLACEHOLDER: "Filtruj wyniki",
  FILTER_WITH_ELLIPSIS: "Filtr...",
  FILTERED_BY_COLUMN_ID: "Filtruj wg. {columnId}",
  FIND_CUSTOMER: "Znajd\u017A klienta",
  FINNISH: "Fi\u0144ski",
  FIRST_MAINTENANCE: "PIERWSZA KONSERWACJA",
  FIRST_NAME: "Imi\u0119",
  FIRST_NAME_IS_REQUIRED: "Wymagane jest podanie imienia",
  FIRST_SHIP_TO_LOCATION: "Miejsce pierwszej dostawy",
  FIRST_USE: "Pierwsze u\u017Cytkowanie",
  FISCAL_YEAR: "Rok fiskalny",
  FLUID_SAMPLING_REQUIRED: "Wymagane pr\xF3bkowanie p\u0142ynu",
  FORWARDED: "PRZEKAZANO",
  FRENCH: "Francuski",
  FRWRD: "Do przodu",
  FULL_DEBIT: "Pe\u0142ny debet",
  GENERAL: "Informacje og\xF3lne",
  GERMAN: "Niemiecki",
  GET_MAINTENANCE_PLANS: "Uzyskaj plany konserwacji",
  GOODS_INSTALLATION_VAT: "Instalacja towar\xF3w \u2014 VAT",
  GRACE_PERIOD: "Okres Prolongaty",
  GREATER_THAN: "Wi\u0119cej ni\u017C",
  GREATER_THAN_OR_EQUALS: "Wi\u0119cej lub r\xF3wno jak",
  GROUP_COMPLETE: "Grupa kompletna",
  GST_PERCENTAGE: "GST Odsetek",
  HISTORY_TO_DISPLAY: "Historia do wy\u015Bwietlenia (dni)",
  HOME: "Strona g\u0142\xF3wna",
  HOUR_LIMIT: "Limit godzin",
  HOURS: "Godziny",
  HOURS_ON_RENT: "Czas wypo\u017Cyczenia (godziny)",
  HSN_SAC_CODE: "HSN/SAC Code",
  IGST: "IGST",
  IMPLEMENTS: "Narz\u0119dzia",
  IN_RANGE: "W zakresie",
  INCENTIVE: "Zach\u0119ta",
  INCENTIVE_PROGRAMS: "Programy motywacyjne",
  INCLUDE_FULLY_COMPLETE: "Do\u0142\u0105cz w pe\u0142ni kompletne PIP",
  INDICATES_REQUIRED_FIELD: "Oznacza wymagane pola",
  INFO_MESSAGE_TITLE: "Wys\u0142ano powiadomienie systemowe",
  INFO_MESSAGES: "Komunikaty informacyjne",
  INFO_MESSAGES_TITLE: "Wys\u0142ano powiadomienia systemowe",
  INFO_REQUEST_STATUS_ERROR: "Informacje s\u0105 gotowe do wys\u0142ania wraz z tym \u017C\u0105daniem.",
  INFORMATION: "Informacja",
  INFORMATION_REQUEST: "\u017B\u0105danie informacji",
  INFORMATION_REQUEST_STATUS: "Status \u017C\u0105dania informacji",
  INPUT_PIN: "Wprowad\u017A PIN",
  INSPECTION: "Kontrola",
  INSTALLED_BY: "Zainstalowane przez",
  INSTALLED_BY_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola \u201EZainstalowane przez\u201D",
  INTERNAL_DEERE_COMMENTS: "Wewn\u0119trzne komentarze Deere",
  INTERVAL_BEGINS: "Pocz\u0105tek okresu",
  INTERVAL_ENDS: "Koniec okresu",
  INTERVAL_TYPE_DESCRIPTION: "Opis rodzaju okresu",
  INVOICE_ACCOUNT: "Konto faktury",
  INVOICE_DEALER: "Dealer fakturowany",
  INVOICE_NUMBER: "Numer faktury",
  INVOICE_REQUEST: "Wniosek o faktur\u0119",
  INVOICE_SENT: "Faktur\u0119 wys\u0142ano",
  INVOICE_UPDATED_SUCCESSFULLY: "Aktualizacja faktury z powodzeniem",
  INVOICED: "Wystawiono faktur\u0119",
  INVOICED_TO: "Wystawiono faktur\u0119 na",
  IRC_PIN_MESSAGE: "Klient jest IRC i jest uprawniony do bezp\u0142atnego czasu podr\xF3\u017Cy i przejazdu przez pierwsze 500 godzin lub 12 miesi\u0119cy posiadania maszyny.",
  ISSUED: "Wydano",
  ITALIAN: "W\u0142oski",
  ITEM: "Elementu",
  ITEM_NUMBER: "Numer elementu",
  ITEM_NUMBER_IS_REQUIRED: "Wymagany jest numer elementu",
  JDLINK_EXPIRES: "Us\u0142uga JDLink wygasa",
  JDP_COMMENTS: "Komentarze JDP",
  JDP_COMMENTS_IS_REQUIRED: "Wymagane s\u0105 komentarze JDP",
  JDP_CUSTOMER_RESOLUTION: "Rozwi\u0105zanie dla klienta JDP",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "Wymagane jest podanie rozwi\u0105zania dla klienta JDP",
  JDP_REASON: "Przyczyna JDP",
  JDP_REASON_IS_REQUIRED: "Wymagane jest podanie przyczyny JDP",
  LABOR: "Praca",
  LABOR_ADDITIVE: "Koszt pracy",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "Szczeg\xF3\u0142y dodatkowej robocizny",
  LABOR_ADDITIVE_PIPS: "Dodatki pracownicze PIP",
  LABOR_ADDITIVE_TAB: "Dodatkowa robocizna ({count})",
  LABOR_ADJUSTMENT: "Regulacja pracy",
  LABOR_COMMENTS: "Praca Uwagi",
  LABOR_HOURS: "Pr. Godziny",
  LABOR_ITEM_DETAILS: "Robocizna \u2014 {quantity} {unit} {description}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "Stawka robocza zosta\u0142a pomy\u015Blnie zatwierdzona",
  LABOR_RATE_CHANGE_SUBMITTED: "Wys\u0142ana zmiana stawki roboczej",
  LABOR_RATE_CHANGES_WITH_COUNT: "Liczba zmian stawki ({count})",
  LABOR_RATE_CONFIRM: "\u017B\u0105dana stawka robocza jest ni\u017Csza od obecnej. Czy na pewno chcesz przes\u0142a\u0107 to \u017C\u0105danie?",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "Tempa w czerwonym tek\u015Bcie oznaczaj\u0105 wzrost o ponad 10% w stosunku do istniej\u0105cego tempa",
  LABOR_RATE_HISTORY: "Historia stawki roboczej",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "Stawka robocza zosta\u0142a pomy\u015Blnie odrzucona",
  LABOR_RATE_REQUESTS_STATUS: "Stan \u017C\u0105da\u0144 stawki pracy",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "Stawka robocza zwr\xF3cona pomy\u015Blnie",
  LABOR_RATES: "Stawki za prac\u0119",
  LABOR_STATS: "Statystyka pracy",
  LABOR_TOTAL: "Praca, \u0142\u0105cznie",
  LABOR_TYPE: "Rodzaj pracy",
  LABOR_VALUE: "Warto\u015B\u0107 pracy",
  LABOR_WITH_COUNT: "Robocizna ({count})",
  LANGUAGE: "J\u0119zyk",
  LAST_LOCATION_FROM: "Ostatnia lokalizacja",
  LAST_NAME: "Nazwisko",
  LAST_NAME_IS_REQUIRED: "Wymagane jest podanie nazwiska",
  LAST_PERSONAL_CONTACT: "Ostatni kontakt osobisty",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "Szczeg\xF3\u0142y dotycz\u0105ce organu \u015Bcigania",
  LAYOUT_CREATED_SUCCESSFULLY: "Uk\u0142ad utworzony pomy\u015Blnie",
  LAYOUT_DELETED_SUCCESSFULLY: "Uk\u0142ad zosta\u0142 usuni\u0119ty pomy\u015Blnie",
  LAYOUT_NAME: "Nazwa uk\u0142adu",
  LAYOUT_UPDATED_SUCCESSFULLY: "Uk\u0142ad zosta\u0142 aktualizacja pomy\u015Blnie",
  LEAD_ACCOUNT: "Konto g\u0142\xF3wne",
  LEAD_DEALER: "G\u0142\xF3wny dealer",
  LESS_THAN: "Mniej ni\u017C",
  LESS_THAN_OR_EQUALS: "Mniej lub r\xF3wno jak",
  LICENSE_PLATE_NUMBER: "Numer rejestracyjny",
  LIFETIME: "\u017Bywotno\u015B\u0107",
  LINE_ITEMS_EXPORT: "Eksport element\xF3w zam\xF3wienia",
  LIST: "Lista",
  LIST_TOTAL: "Suma lista",
  LOCATION: "Lokalizacja",
  LOCATION_DUE: "Lokalizacja docelowa",
  LOCATIONS: "Lokalizacje",
  LOCATIONS_WITH_COUNT: "Liczba lokalizacji ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "Maszyna jest ju\u017C zarejestrowana dla tego klienta",
  MACHINE_INFORMATION: "Informacje o urz\u0105dzeniu",
  MACHINE_MODEL_TYPE: "Model/typ maszyny",
  MACHINE_MODEL_TYPE_REQUIRED: "Wymagany model/typ maszyny",
  MACHINE_STATUS: "Status maszyny",
  MACHINE_STATUS_UPDATE_ACCEPTED: "Aktualizacja stanu maszyny zatwierdzona",
  MACHINE_STATUS_UPDATE_DOCUMENT: "Dokument aktualizacji stanu maszyny",
  MACHINE_STATUS_UPDATE_REJECTED: "Aktualizacja stanu maszyny odrzucona",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "Aktualizacje stanu maszyny ({count})",
  MACHINE_TYPE: "Rodzaj maszyny",
  MACHINE_TYPE_IS_REQUIRED: "Wymagane jest podanie rodzaju maszyny",
  MACHINE_USE: "U\u017Cytkowanie maszyny",
  MAILING_RECIPIENT: "Adresat korespondencji (imi\u0119 i nazwisko)",
  MAILING_RECIPIENT_REQUIRED: "Wymagany adresat korespondencji",
  MAINTENANCE: "Konserwacja",
  MAINTENANCE_PLAN: "Plany konserwacji",
  MAINTENANCE_PLAN_INFO: "Informacje o planie konserwacji",
  MARK_AS_REVIEW: "Oznacz jako poprawione",
  MARKETING_INCENTIVE: "Marketing \u2014 Zach\u0119ta",
  MARKETING_JD_PROMISE: "Marketing \u2014 obietnica JD",
  MARKETING_MAINTENANCE_PLAN: "Marketing \u2014 plan przegl\u0105d\xF3w",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "Marketing \u2014 kana\u0142 masowy \u2014 dzia\u0142ania kontynuacyjne",
  MARKETING_MASS_CHANNEL_PDI: "Marketing \u2014 kana\u0142 masowy \u2014 PDI",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "Przekazanie klienta masowego",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "Pami\u0119taj, \u017Ceby skontaktowa\u0107 si\u0119 z radc\u0105 prawnym w kwestii w\u0142a\u015Bciwych procedur dotycz\u0105cych numer\xF3w zastrze\u017Conych obowi\u0105zuj\u0105cych w Twoim wojew\xF3dztwie, a tak\u017Ce na poziomie pa\u0144stwowym, zanim wprowadzisz zmiany w programie dotycz\u0105cym kontaktu posprzeda\u017Cowego",
  MASS_CHANNEL_PDI_CLAIM: "Kana\u0142 masowy \u2014 PDI",
  MASTER_WARRANTY_TYPE: "Typ gwarancji g\u0142\xF3wnej",
  MATERIAL: "Numer materia\u0142u",
  MERCHANDISE: "Artyku\u0142y r\xF3\u017Cne",
  MESSAGE: "Wiadomo\u015B\u0107",
  MESSAGES: "Wiadomo\u015Bci",
  METHOD_OF_CONTACT: "Metoda kontaktu",
  METHOD_OF_CONTACT_IS_REQUIRED: "Wymagane jest podanie metody kontaktu",
  METRIC: "Metryka",
  METRICS: "Jednostki metryczne",
  MILEAGE_LIMIT: "Limit przebiegu",
  MOBILE_PHONE: "Telefon kom\xF3rkowy",
  MODEL: "Model",
  MODEL_NUMBER: "Numer modelu",
  MODIFIED: "Zmodyfikowano",
  MONTH_TO_DATE: "W bie\u017C\u0105cym miesi\u0105cu",
  MORE: "Jeszcze",
  MULTIPLE: "Wiele",
  NAME: "Imi\u0119 i nazwisko",
  NET: "Netto",
  NET_AMOUNT: "Kwota netto",
  NET_AMOUNT_PAID: "Uiszczona kwota netto",
  NET_TOTAL: "Suma netto",
  NEW: "NOWY",
  NEW_ACCOUNT: "Nowe konto",
  NEW_CLAIM: "Nowe roszczenie",
  NEW_CLAIM_VALUE: "Nowa warto\u015B\u0107 reklamacji",
  NEW_CUSTOMER_REQUIRED: "Wymagany nowy klient",
  NEW_DEALER: "Nowy dealer",
  NEW_DEALER_DISTANCE: "Odleg\u0142o\u015B\u0107 nowego sprzedawcy",
  NEW_DEALER_LOCATION: "Lokalizacja nowego dealera",
  NEW_LABOR_RATE: "Nowa stawka robocza",
  NEW_REQUEST_ENTER_RATES: "Nowe \u017C\u0105danie - wprowad\u017A stawki",
  NEW_STATUS: "Nowy status",
  NEW_TRANSFER: "Nowy transfer",
  NEW_TRANSFER_CREATED: "Utworzono nowy transfer",
  NEW_VALUE: "Nowa warto\u015B\u0107",
  NO: "NIE",
  NO_ACTIVE_WARRANTY: "Brak wa\u017Cnej gwarancji",
  NO_AFFECTED_PINS: "Nie ma \u017Cadnych numer\xF3w PIN, za kt\xF3re odpowiedzialna by\u0142aby Twoja dzia\u0142alno\u015B\u0107 handlowa",
  NO_AUTHORITY_TO_ACCESS: "Nie masz uprawnie\u0144 dost\u0119pu do sieci JDWS. Aby zweryfikowa\u0107 uprawnienia, nale\u017Cy skontaktowa\u0107 si\u0119 z pomoc\u0105 techniczn\u0105 i skontaktowa\u0107 si\u0119 z pomoc\u0105 techniczn\u0105, korzystaj\u0105c z kopii tego b\u0142\u0119du tutaj",
  NO_CLAIMS: "Brak roszcze\u0144.",
  NO_CUSTOMER_ASSOCIATED: "Brak powi\u0105zanego klienta",
  NO_CUSTOMER_SELECTED: "\u017Baden klient nie zosta\u0142 wybrany",
  NO_DEALER_INVOICES: "Brak faktur dealera",
  NO_DEALERS_MAPPED: "Brak dealer\xF3w powi\u0105zanych z Twoim identyfikatorem u\u017Cytkownika. Skontaktuj si\u0119 z administratorem systemu.",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "Nie (je\u017Celi nie, zdj\u0119cie musi by\u0107 przedstawione jako dow\xF3d)",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "No information available for this product",
  NO_LOWERCASE: "Nie",
  NO_MATCHING_DEALERS: "Brak dealer\xF3w spe\u0142niaj\u0105cych warunki filtrowania.",
  NO_OPEN_PART_REQUESTS: "Brak otwartych pr\xF3\u015Bb o cz\u0119\u015Bci",
  NO_OPEN_PIPS: "Brak oczekuj\u0105cych roszcze\u0144 PIP",
  NO_PARTS_RETURNED: "Nie zwr\xF3cono \u017Cadnych cz\u0119\u015Bci",
  NO_PIP_PRODUCTS: "Brak produkt\xF3w PIP.",
  NO_PRODUCT_FOUND: "Brak znalezionych produkt\xF3w",
  NO_REQUIRED_ITEMS: "Brak wymaganych element\xF3w.",
  NO_RESULTS: "Brak wynik\xF3w",
  NO_RESULTS_FOUND: "Brak wynik\xF3w",
  NO_ROWS_TO_SHOW: "Brak p\xF3l do wy\u015Bwietlenia",
  NO_SPECIAL_INSTRUCTIONS: "Brak specjalnych instrukcji.",
  NO_TRAVEL: "Brak podr\xF3\u017Cy",
  NON_RECOVERABLE_TAXES: "Brak podatku do zwrotu",
  NON_TRACKED_PINS_HELP_TEXT: "Niekt\xF3re produkty b\u0119d\u0105 wy\u015Bwietlane w gwarancji dopiero po rejestracji. Twoje kryteria wyszukiwania obejmuj\u0105 te produkty.",
  NON_TRAVEL: "Brak podr\xF3\u017Cy",
  NONE: "Brak",
  NORMAL: "NORMALNY",
  NOT_EQUAL: "Nier\xF3wny",
  NOTIFICATION_ADDED_SUCCESSFULLY: "Powiadomienie dodane pomy\u015Blnie",
  NOTIFICATION_DELETED_SUCCESSFULLY: "Powiadomienie usuni\u0119te pomy\u015Blnie",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "Sekwencja powiadomie\u0144 zosta\u0142a pomy\u015Blnie zaktualizowana",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "Powiadomienie zaktualizowane pomy\u015Blnie",
  NOTIFICATIONS: "Powiadomienia",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "Liczba diagnostyk",
  NUMBER_OF_OPEN_PIPS: "Liczba otwartych program\xF3w poprawy produktu (PIP) {number}",
  NUMBER_OF_REPAIR_OCCURRENCES: "Liczba napraw",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "Liczba wymian",
  OLD_LABOR_RATE: "Dotychczasowa stawka robocza",
  ON_SHELF: "W magazynie",
  ON_SHELF_COST: "Cena ko\u0144cowa",
  ONE_ITEM_MUST_BE_SELECTED: "Nale\u017Cy wybra\u0107 jeden element",
  OPEN: "Oczekuj\u0105cy",
  OPEN_PART_REQUESTS: "Otw\xF3rz wnioski o cz\u0119\u015Bci",
  OPEN_PART_REQUESTS_WITH_COUNT: "Otwarte wnioski o cz\u0119\u015Bci ({count})",
  OPEN_PIP_COUNT: "Otw\xF3rz licznik PIP",
  OPEN_PIP_PROGRAMS: "Rejestr PIP",
  OPEN_PIPS: "Otwarte PIP",
  OPEN_PIPS_REPORT: "Otw\xF3rz raport PIP",
  OPEN_PIPS_TAB: "Oczekuj\u0105ce roszczenia PIP ({count})",
  OPERATORS_COMPLAINT: "Czego dotyczy\u0142a reklamacja operatora?",
  OPERATORS_COMPLAINT_IS_REQUIRED: "Wymagana jest reklamacja operatora",
  OPERATORS_MANUAL_NUMBER: "Numer Instrukcji obs\u0142ugi",
  OPTION_CODE: "Kod opcji",
  OPTION_CODE_CREATED_SUCCESSFULLY: "Kod opcji stworzony pomy\u015Blnie",
  OPTION_CODE_DELETED_SUCCESSFULLY: "Kod opcji usuni\u0119ty pomy\u015Blnie",
  OPTION_CODES: "Kody opcji",
  OR: "lub",
  ORIGINAL_CLAIM_VALUE: "Pierwotna warto\u015B\u0107 reklamacji",
  ORIGINAL_SUBMISSION_DATE: "Oryginalna data wys\u0142ania",
  ORIGINALLY_SUBMITTED: "Pocz\u0105tkowo przes\u0142ano",
  OTHER: "Inne",
  OTHER_AMOUNT_OF_USE: "Inny Czas U\u017Cytkowania",
  OTHER_AMOUNT_OF_USE_REQUIRED: "Wymagany inny czas u\u017Cytkowania",
  OTHER_CREDIT: "Inny koszt",
  OTHER_CREDIT_1: "Inny koszt 1",
  OTHER_CREDIT_2: "Inny koszt 2",
  OTHER_CREDIT_3: "Inny koszt 3",
  OTHER_CREDIT_ADJUSTMENT: "Korekta innych koszt\xF3w",
  OTHER_CREDIT_ITEM_DETAILS: "Inny koszt - {description} ({quantity} {unit})",
  OTHER_CREDIT_TOTAL: "Ca\u0142kowita liczba innych kredyt\xF3w",
  OTHER_CREDITS: "Inne koszty",
  OTHER_CREDITS_WITH_COUNT: "Inne punkty ({count})",
  OTHER_INSTRUCTIONS: "Inne instrukcje",
  OUTPUT_PIN: "Wyj\u015Bciowy kod PIN",
  OVERDUE: "Termin up\u0142yn\u0105\u0142",
  OVERRIDE_ACCOUNT: "Nadpisz konto",
  OVERRIDE_EFFECTIVE_DATE: "Data zast\u0105pienia",
  OVERRIDE_SUGGESTED_ACCOUNT: "Nadpisz sugerowane konto",
  OWNERSHIP_STATUS: "Status w\u0142asno\u015Bciowy",
  OWNERSHIP_STATUS_IS_REQUIRED: "Wymagane jest podanie statusu w\u0142asno\u015Bciowego",
  PART: "Cz\u0119\u015B\u0107",
  PART_1: "Cz\u0119\u015B\u0107 1",
  PART_2: "Cz\u0119\u015B\u0107 2",
  PART_3: "Cz\u0119\u015B\u0107 3",
  PART_4: "Cz\u0119\u015B\u0107 4",
  PART_5: "Cz\u0119\u015B\u0107 5",
  PART_6: "Cz\u0119\u015B\u0107 6",
  PART_7: "Cz\u0119\u015B\u0107 7",
  PART_8: "Cz\u0119\u015B\u0107 8",
  PART_9: "Cz\u0119\u015B\u0107 9",
  PART_10: "Cz\u0119\u015B\u0107 10",
  PART_AMONT_OF_USE: "Czas u\u017Cytkowania cz\u0119\u015Bci",
  PART_FAMILY: "Rodzina cz\u0119\u015Bci",
  PART_ITEM_DETAILS: "Cz\u0119\u015Bci \u2014 {quantity} {description}; numer cz\u0119\u015Bci {partNumber}",
  PART_NUMBER: "Numer cz\u0119\u015Bci",
  PART_REQUEST: "Wniosek o cz\u0119\u015B\u0107",
  PART_REQUEST_NUMBER: "Wniosek o cz\u0119\u015Bci {rgaNumber}",
  PART_REQUEST_STATUS: "Status wniosku o cz\u0119\u015Bci",
  PART_REQUESTS: "Wnioski o cz\u0119\u015Bci",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "Wprowad\u017A numer roszczenia, przynajmniej 4 znaki",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "Wyszukiwana nazwa roszczenia musi sk\u0142ada\u0107 si\u0119 przynajmniej z 4 znak\xF3w",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "Wyszukiwany numer przypadku DTAC musi by\u0107 pe\u0142ny i sk\u0142ada\u0107 si\u0119 przynajmniej z 4 znak\xF3w",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "Wprowad\u017A pe\u0142ny numer przypadku DTAC",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "Wyszukiwany numer cz\u0119\u015Bci musi sk\u0142ada\u0107 si\u0119 przynajmniej z 4 znak\xF3w",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "Wprowad\u017A numer cz\u0119\u015Bci, przynajmniej 4 znaki",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "Wyszukiwany numer wniosku o cz\u0119\u015B\u0107 musi sk\u0142ada\u0107 si\u0119 przynajmniej z 4 znak\xF3w",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "Wprowad\u017A numer wniosku o cz\u0119\u015B\u0107, przynajmniej 4 znaki",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "Wyszukiwany PIN musi sk\u0142ada\u0107 si\u0119 przynajmniej z 4 znak\xF3w",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "Wprowad\u017A PIN, przynajmniej 4 znaki",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "Wyszukiwana nazwa harmonogramu pracy musi by\u0107 pe\u0142na i sk\u0142ada\u0107 si\u0119 przynajmniej z 2 znak\xF3w",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "Wprowad\u017A pe\u0142ny harmonogram pracy",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "Pomy\u015Blnie zaktualizowano wniosek o cz\u0119\u015B\u0107",
  PART_RETURN: "Wniosek o zwrot cz\u0119\u015Bci",
  PART_RETURNS: "Zwroty cz\u0119\u015Bci",
  PART_SERIAL_NUMBER: "Numer seryjny cz\u0119\u015Bci",
  PART_SERIAL_NUMBER_IS_REQUIRED: "Wymagany jest numer seryjny cz\u0119\u015Bci",
  PART_TOTAL: "Og\xF3\u0142 cz\u0119\u015Bci",
  PART_TYPE: "Rodzaj cz\u0119\u015Bci",
  PART_USE: "Zu\u017Cycie cz\u0119\u015Bci",
  PART_VALUE: "Warto\u015B\u0107 cz\u0119\u015Bci",
  PARTIAL_DEBIT: "Cz\u0119\u015Bciowy debet",
  PARTICIPANT: "Uczestnik",
  PARTS: "CZ\u0118\u015ACI",
  PARTS_ADDITIVE: "Dodatkowe koszty cz\u0119sci",
  PARTS_ADJUSTMENT: "Regulacja cz\u0119\u015Bci",
  PARTS_COVERAGE_SEARCH: "Wyszukiwanie pokrycia cz\u0119\u015Bci",
  PARTS_TEMPLATE: "Szablon cz\u0119\u015Bci",
  PARTS_USE: "U\u017Cycie cz\u0119\u015Bci",
  PARTS_USE_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola \u201EZu\u017Cycie cz\u0119\u015Bci\u201D",
  PARTS_WITH_COUNT: "Cz\u0119\u015Bci ({count})",
  PARTS_WITH_PARENTHESES: "Cz\u0119\u015Bci",
  PAST_DUE: "Po terminie",
  PAYER_ACCOUNT: "Konto p\u0142atnika",
  PERCENT_COMPLETE: "Procent uko\u0144czony",
  PERCENTAGE: "Odsetek",
  PERCENTAGE_DEBIT: "Obci\u0105\u017Cenie procentowe",
  PERCENTAGE_SYMBOL: "{percentage}%",
  PERCENTAGE_TO_DEBIT: "Procent do obci\u0105\u017Cenia",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "W przypadku maszyn trwale nieczynnych nale\u017Cy do\u0142\u0105czy\u0107 zdj\u0119cie maszyny w celu sprawdzenia, czy nie mo\u017Cna odbudowa\u0107, naprawi\u0107 ani u\u017Cy\u0107 maszyny w \u017Cadnym momencie w przysz\u0142o\u015Bci. Maszyny stacjonarne z wy\u0142\u0105czonym systemem kwalifikuj\u0105 si\u0119 do PIP dowolnego rodzaju.",
  PERSON_RESPONSIBLE: "Osoba odpowiedzialna",
  PHONE: "TELEFON",
  PHONE_REQUIRED: "Wymagany jest telefon",
  PICTURE: "Obraz",
  PICTURE_REQUEST: "Pro\u015Bba o zdj\u0119cia",
  PICTURE_REQUEST_STATUS: "Status pro\u015Bba o zdj\u0119cia",
  PICTURE_REQUEST_STATUS_ERROR: "Attachments are ready to be sent along with this request.",
  PIN: "PIN",
  PIN_CREATED_SUCCESSFULLY: "Numer PIN zosta\u0142 pomy\u015Blnie utworzony",
  PIN_CROSS_REFERENCE: "Numer PIN referencji krzy\u017Cowej",
  PIN_INVALID: "Nieprawid\u0142owy kod PIN",
  PIN_IS_REQUIRED: "Wymagany jest kod PIN",
  PIN_REQUIRED: "Wymagany kod PIN",
  PIN_SEARCH: "Wyszukiwanie PIN",
  PIN_SEARCH_INFORMATION: "Informacje dotycz\u0105ce wyszukiwania PIN",
  PIN_TRANSFER_INFORMATION: "Informacje dotycz\u0105ce transferu PIN",
  PINS: "Numery PIN",
  PINS_NOT_REGISTERED: "Kody PIN nie s\u0105 zarejestrowane",
  PIP: "PIP",
  PIP_CODE: "Kod PIP",
  PIP_CODE_CREATED_SUCCESSFULLY: "Pomy\u015Blnie utworzono wniosek o kod PIP",
  PIP_CODE_REQUEST: "Wniosek o kod PIP",
  PIP_CODE_REQUEST_APPROVED: "Wniosek o kod PIP zatwierdzony",
  PIP_CODE_REQUEST_REJECTED: "Wniosek o kod PIP odrzucony",
  PIP_CODE_REQUESTS_WITH_COUNT: "Wnioski o kod PIP ({count})",
  PIP_COMPLETION_STATUS: "Status kompletno\u015Bci PIP",
  PIP_DETAILS: "Szczeg\xF3\u0142y kodu PIP",
  PIP_HISTORY: "Historia PIP",
  PIP_ID: "Nr PIP",
  PIP_NUMBER: "Numer PIP",
  PIP_PROGRAM: "Program PIP",
  PIP_PROGRAM_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola \u201EProgram PIP\u201D",
  PIP_PROGRAMS: "Programy PIP",
  PIP_SEARCH: "Wyszukiwanie PIP",
  PIP_STATUS: "Status PIP",
  PIP_TYPE: "Rodzaj numeru PIP",
  PIP_TYPES: "Rodzaj PIP",
  PIPS: "PIP",
  PIPS_UNPAID_LABOR_ADDITIVE: "Niep\u0142atne dodatki pracownicze PIP",
  PLAN_DESCRIPTION: "Opis planu",
  PLAN_END_DATE: "Planowana data zako\u0144czenia",
  PLAN_ENDS: "Data zako\u0144czenia planu",
  PLAN_NAME: "Nazwa planu",
  PLAN_NAME_IS_REQUIRED: "Wymagana jest nazwa planu",
  PLAN_NAMES: "Nazwy plan\xF3w",
  PLAN_START_DATE: "Planowana data rozpocz\u0119cia",
  PLAN_STARTS: "Data rozpocz\u0119cia planu",
  PLANNED_BY: "Planowane przez",
  PLANT: "Zak\u0142ad",
  PLATE_REQUEST_INFORMATION: "Informacje o \u017C\u0105daniu tabliczki",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "Wybierz g\u0142\xF3wne konto",
  PLEASE_SELECT_CLAIM_TYPE: "Wybierz typ roszczenia",
  POLISH: "Polskie",
  PORTUGUESE: "Portugalski",
  POSTAGE_DELIVERY_DATE: "Data dostawy przesy\u0142ki",
  POSTAL_CODE: "Kod pocztowy",
  POSTAL_CODE_REQUIRED: "Wymagany kod pocztowy",
  POSTAL_TRACKING_NUMBER: "Nr \u015Bledzenia przesy\u0142ki",
  POTENTIAL_RESPONSIBLE_DEALER: "Potencjalny odpowiedzialny sprzedawca",
  PRE_DELIVERY_INSPECTION: "Kontrola przed dostaw\u0105",
  PREFERRED_THEME: "Preferowany motyw",
  PREPARE_AUDIT: "Przygotuj audyt",
  PREPARED: "Przygotowane",
  PREPARING_AUDIT_FOR_WITH_DEALER: "Przygotowywanie audytu dla dealera {dealer}",
  PREVIOUS_AMOUNT_OF_USE: "Poprzedni Czas U\u017Cytkowania",
  PREVIOUS_INVOICE_NUMBER: "Numer poprzedniej faktury",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "Wymagany jest numer poprzedniej faktury",
  PREVIOUS_MONTH: "W poprzednim miesi\u0105cu",
  PRICE: "Cena",
  PRICING_SUMMARY: "Podsumowanie wyceny",
  PRIMARY_ACTION: "G\u0142\xF3wne dzia\u0142anie",
  PRIMARY_LANGUAGE: "G\u0142\xF3wny j\u0119zyk",
  PRINT: "Drukuj",
  PRINT_CLAIM: "Drukuj roszczenie",
  PRINT_REGISTRATION_FORM: "Drukuj formularz rejestracyjny ?",
  PRINT_REGISTRATION_FORM_MESSAGE: "Produkt zarejestrowany na pierwszego w\u0142a\u015Bciciela. Czy wydrukowa\u0107 formularz rejestracyjny ?",
  PRINT_TO_PDF: "Drukuj PDF",
  PRIORITY: "Priorytet",
  PRNT_CLM: "Wy\u015Bwietl reklamacj\u0119",
  PROCESS_DATE: "Data przetworzenia",
  PROCESSED: "Przetworzono",
  PROCESSED_PART_REQUESTS: "Przetworzone \u017C\u0105dania cz\u0119\u015Bci",
  PROCESSING_STATUS: "Status przetwarzania",
  PROCESSING_STATUS_DESCRIPTION: "Przetwarzanie opisu statusu",
  PRODUCT_DETAILS: "Szczeg\xF3\u0142y produkt\xF3w",
  PRODUCT_HIERARCHY: "Hierarchia produktu",
  PRODUCT_INFORMATION: "Informacje o produkcie",
  PRODUCT_REGISTERED: "Produkt zarejestrowany",
  PRODUCT_REGISTRATION: "Rejestracja produktu",
  PRODUCT_REGISTRATION_PENDED: "Rejestracja produktu wstrzymana",
  PRODUCT_TRACKING: "\u015Aledzenie produktu",
  PRODUCTS: "Produkty",
  PRODUCTS_BY_CUSTOMER: "Produkty wed\u0142ug klienta",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "Historyczne kody PIN mog\u0105 nie by\u0107 dost\u0119pne w wynikach wyszukiwania z powodu przej\u015Bciowego problemu z \u0142\u0105czno\u015Bci\u0105 systemu",
  PRODUCTS_WITH_COUNT: "Produkty ({count})",
  PROGRAM: "Programu",
  PROGRAM_DESCRIPTION: "Opis programu",
  PROGRAM_IS_REQUIRED: "Nazwa programu jest wymagana.",
  PROGRAM_NAME: "Nazwa programu",
  PROGRAM_NAME_IS_REQUIRED: "Nazwa programu jest wymagana.",
  PROGRAM_NUMBER: "Numer programu",
  PRT: "PRT",
  PRTS: "PRT",
  PURCHASE_INFO: "Informacje o zakupie",
  PURCHASE_ORDER: "Zam\xF3wienie zakupu",
  PURCHASE_ORDER_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola \u201EZam\xF3wienie zakupu\u201D",
  PURCHASER_TYPE: "Rodzaj kupuj\u0105cego",
  PURCHASER_TYPE_REQUIRED: "Wymagany rodzaj kupuj\u0105cego",
  PUSH_XML: "Wy\u015Blij ponownie XML",
  QTY: "Il.",
  QUALIFY_FOR_EMISSIONS: "Zakwalifikowa\u0107 do uk\u0142adu wydechowego",
  QUANTITY: "Ilo\u015B\u0107",
  QUANTITY_1: "Ilo\u015B\u0107 1",
  QUANTITY_2: "Ilo\u015B\u0107 2",
  QUANTITY_3: "Ilo\u015B\u0107 3",
  QUANTITY_4: "Ilo\u015B\u0107 4",
  QUANTITY_5: "Ilo\u015B\u0107 5",
  QUANTITY_6: "Ilo\u015B\u0107 6",
  QUANTITY_7: "Ilo\u015B\u0107 7",
  QUANTITY_8: "Ilo\u015B\u0107 8",
  QUANTITY_9: "Ilo\u015B\u0107 9",
  QUANTITY_10: "Ilo\u015B\u0107 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "Zapytanie musi mie\u0107 co najmniej 3 znaki",
  QUEST_DESC: "Opis nieprawid\u0142owego",
  QUESTIONABLE_PART: "W\u0105tpliwa cz\u0119\u015B\u0107",
  QUEUED: "W kolejce",
  REASON_FOR_CHANGE: "Przyczyna zmiany",
  REASON_FOR_DEBIT: "Przyczyna debetu",
  REASON_FOR_MISSING_PLATE: "Przyczyna braku tabliczki",
  REASON_FOR_MISSING_PLATE_REQUIRED: "Wymagana przyczyna braku tabliczki",
  REASON_FOR_OVERRIDE: "Przyczyna zast\u0105pienia",
  REASON_FOR_REFUSAL: "Pow\xF3d odmowy",
  REASON_FOR_RETURN: "Pow\xF3d zwrotu",
  REASON_FOR_RETURN_IS_REQUIRED: "Wymagane jest podanie powodu zwrotu",
  REASON_FOR_TRANSFER: "Pow\xF3d transferu",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "Pow\xF3d transferu musi si\u0119 sk\u0142ada\u0107 ze znak\xF3w alfanumerycznych",
  RECIPIENT_DEALER_OR_TCSM: "Odbiorca (dealer lub TCSM)",
  RECIPIENT_MAILING: "Adresat korespondencji",
  RECONCILE: "Uzgodnienie",
  RECONCILE_CLAIM: "Uzgodnij roszczenie",
  RECONCILED: "UZGODNIONE",
  RECORD_AUDIT: "Zapis audytu",
  RECORD_AUDIT_FOR: "Zapis audytu dla u\u017Cytkownika {dealer}",
  RECORDS_FOUND: "Znalezione dokumenty {countToDisplay}",
  RECOVERABLE_TAXES: "Podatek do zwrotu",
  RECOVERED: "Odzyskano",
  RECOVERED_WITH_MISSED_ADDITIVES: "Odzyskano z brakuj\u0105cymi dodatkami",
  RECOVERED_WITHOUT_ADDITIVES: "Odzyskano bez dodatk\xF3w",
  RECOVERY: "Odzyskiwanie",
  RED_MUST_BE_LESS_THAN_YELLOW: "Warto\u015B\u0107 czerwonego wska\u017Anika musi by\u0107 ni\u017Csza od warto\u015Bci \u017C\xF3\u0142tego wska\u017Anika",
  REFERENCE_1: "Referencja 1",
  REFERENCE_2: "Odno\u015Bnik 2",
  REFERENCE_INFORMATION: "Informacja referencyjna",
  REFERENCE_NUMBER1: "Numer referencyjny 1",
  REFERENCE_NUMBER2: "Numer referencyjny 2",
  REGION: "Region",
  REGISTER: "Zarejestruj",
  REGISTER_A_PRODUCT_BY_PIN: "Zarejestruj produkt wg kodu PIN",
  REGISTER_A_PRODUCT_TO_ADD: "Zarejestruj produkt i dodaj do systemu gwarancji",
  REGISTER_ANOTHER_PRODUCT: "Zarejestruj si\u0119 inny produkt",
  REGISTER_PRODUCT: "Zarejestruj produkt",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "Zarejestruj produkt i dodaj inny",
  REGISTERED: "Zarejestrowano",
  REGISTRATION: "Rejestracja",
  REGISTRATION_DATE: "Data rejestracji",
  REGISTRATION_DATES: "Daty rejestracji",
  REGISTRATION_FORM: "Formularz rejestracji",
  REGISTRATION_HISTORY: "Historia rejestracji",
  REGISTRATION_NOT_ALLOWED: "Brak mo\u017Cliwo\u015Bci rejestracji tego produktu",
  REGISTRATION_REVIEW: "Przegl\u0105d rejestracji",
  REGISTRATION_REVIEW_TAB: "Przegl\u0105d rejestracji ({count})",
  REGISTRATION_STATUS: "Status rejestracji",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "Statusu rejestracji nie mo\u017Cna ustawi\u0107 jako \u201ENowy\u201D",
  REGISTRATION_STATUS_REQUIRED: "Wymagany status rejestracji",
  REGISTRATION_SUCCESS: "Rejestracja powiod\u0142a si\u0119",
  REGISTRATION_TYPE: "Rodzaj rejestracji",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "Rodzaju rejestracji nie mo\u017Cna ustawi\u0107 jako \u201ENowy\u201D",
  REGISTRATION_TYPE_REQUIRED: "Wymagany rodzaj rejestracji",
  REGISTRATION_UPDATED_SUCCESSFULLY: "Rejestracja zaktualizowana pomy\u015Blnie",
  REGISTRATIONS_REVIEW: "Przegl\u0105d rejestracji",
  REIMBURSED: "Zwr\xF3cono koszty",
  REIMBURSED_AMOUNT: "Zwr\xF3cona kwota",
  REIMBURSED_PERCENTAGE: "Zwr\xF3cona kwota (w procentach)",
  REIMBURSED_PERCENTAGE_INDICATOR: "Wska\u017Anik zwr\xF3conej kwoty (w procentach)",
  REIMBURSEMENT_DETAILS: "Szczeg\xF3\u0142y dotycz\u0105ce zwrotu koszt\xF3w",
  REIMBURSEMENT_PERCENTAGE: "Zwrot koszt\xF3w (w procentach)",
  REIMBURSEMENT_SUMMARY: "Zestawienie zwrotu koszt\xF3w",
  REJECT: "Odrzu\u0107",
  REJECT_LABOR_RATE: "Odrzu\u0107 stawk\u0119 robocz\u0105",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "Odrzu\u0107 roszczenie dotycz\u0105ce przydzia\u0142u specjalnego",
  REJECTED: "ODRZUCONY",
  REJECTED_APPEAL: "ODWO\u0141ANIE ODRZUCONE",
  RELATIONSHIP: "Zwi\u0105zek",
  RELATIONSHIP_IS_REQUIRED: "Wymagane jest podanie relacji",
  REMOVE_FILTER: "Usu\u0144 filtr",
  REMOVE_FROM_AUDIT: "Usu\u0144 z audytu",
  REMOVE_LAYOUT: "Usu\u0144 uk\u0142ad",
  RENTAL_PINS: "PIN-y wynajmu",
  REPAIR_DATE: "Data naprawy",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "Data naprawy nie mo\u017Ce by\u0107 wcze\u015Bniejsza ni\u017C data wyst\u0105pienia usterki",
  REPAIR_NUMBER: "Numer naprawy",
  REPAIR_NUMBER_IS_REQUIRED: "Wymagany jest numer naprawy",
  REPAIR_REPLACE_INDICATOR: "Wska\u017Anik napraw/wymian",
  REPAIRED: "Naprawione",
  REPAIRED_DATE: "Data naprawy",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "Data naprawy nie mo\u017Ce by\u0107 wcze\u015Bniejsza ni\u017C data usterki",
  REPAIRED_DATE_IS_REQUIRED: "Wymagana jest data naprawy",
  REPORT_DATE: "Data raportu",
  REPORT_NUMBER: "Numer raportu",
  REPORTS: "Raporty",
  REQ_ADDL: "Dopasuj kredyt",
  REQUEST_DATE: "Data \u017C\u0105dania",
  REQUEST_DETAILS: "Szczeg\xF3\u0142y wniosku",
  REQUEST_DUPLICATE_PIN_PLATE: "Za\u017C\u0105daj zduplikowanej tabliczki z numerem PIN",
  REQUEST_FORM: "Formularz wniosku",
  REQUEST_PIP_CODE: "Prze\u015Blij wniosek o kod PIP",
  REQUEST_STATUS: "Status wniosku",
  REQUEST_SUBMITTED: "Wniosek wys\u0142any",
  REQUEST_TYPE: "Typ \u017C\u0105dania",
  REQUEST_UPDATED_SUCCESSFULLY: "\u017B\u0105danie zaktualizowane pomy\u015Blnie",
  REQUEST_WARRANTY_CLAIM_DEBIT: "Roszczenie o sprawdzenie obci\u0105\u017Cenia gwarancyjnego",
  REQUESTED: "\u017B\u0105danie",
  REQUESTED_BY: "Wymagane przez",
  REQUESTED_DATE: "Wybrana data",
  REQUESTED_DATES: "Wymagane daty",
  REQUESTED_DIAGNOSTIC_AMOUNT: "Po\u017C\u0105dany kwota diagnostyczna",
  REQUESTED_DIAGNOSTIC_HOURS: "Po\u017C\u0105dany godziny diagnostyczne",
  REQUESTED_LABOR_AMOUNT: "Oczekiwane koszty pracy",
  REQUESTED_LABOR_HOURS: "Wymagane godziny pracy",
  REQUESTED_OTHER_CREDITS: "Inne kredyty, o kt\xF3re z\u0142o\u017Cono wnioski",
  REQUESTED_PARTS: "Cz\u0119\u015Bci, o kt\xF3re z\u0142o\u017Cono wnioski",
  REQUESTED_REPAIR_AMOUNT: "Po\u017C\u0105dany kwota naprawy",
  REQUESTED_REPAIR_HOURS: "Po\u017C\u0105dany godziny naprawy",
  REQUESTED_TRAVEL_TOTAL: "Ca\u0142kowita liczba wnioskowanych podr\xF3\u017Cy",
  REQUESTER_TCSM: "Zg\u0142aszaj\u0105cy (TCSM)",
  REQUESTER_TCSM_REQUIRED: "Wymagany zleceniodawca (TCSM)",
  REQUIRED: "wymagane",
  REQUIRED_CRITERIA: "Wymagane kryteria",
  REQUIRED_ITEMS: "Wymagane elementy",
  RESEND_XML: "Wy\u015Blij ponownie XML",
  RESET: "Zeruj",
  RESPONDENT_INFORMATION: "Informacje dotycz\u0105ce respondenta",
  RESPONSIBILITY_OF: "Osoba odpowiedzialna",
  RESPONSIBLE_ACCOUNT: "Konto winnego",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "Wymagane jest konto winnego",
  RESPONSIBLE_DEALER: "Odpowiedzialny dealer",
  RET: "Zwrot",
  RETAIL_INSTALL: "Sprzeda\u017C/instalacja",
  RETAIL_INSTALL_DATE: "Data sprzeda\u017Cy/instalacji",
  RETAIL_INSTALL_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola \u201ESprzeda\u017C/instalacja\u201D",
  RETAILER_NAME: "Nazwa sprzedawcy",
  RETAILER_NAME_IS_REQUIRED: "Wymagana jest nazwa sprzedawcy",
  RETRY: "spr\xF3buj",
  RETURN: "Powr\xF3t",
  RETURN_LABOR_RATE: "Zwrot stawki",
  RETURN_REQUEST: "Powr\xF3t \u017C\u0105danie",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "Zwr\xF3\u0107 roszczenie dotycz\u0105ce przydzia\u0142u specjalnego",
  RETURN_STATUS: "Status zwrotu",
  RETURNED: "ZWR\xD3CONY",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "Data zwrotu nie mo\u017Ce by\u0107 wcze\u015Bniejsza ni\u017C data dostarczenia",
  RETURNED_DATE_IS_REQUIRED: "Wymagane jest podanie daty zwrotu",
  REVIEW_DEALER_RECOMMENDATIONS: "Czy na pewno chcesz oznaczy\u0107 pin do recenzji?",
  REVISE: "Sprawd\u017A",
  REVISED: "ZMODYFIKOWANO",
  ROLLING_12_CREDIT_AMOUNT: "Przewi\u0144 12 kwot kredyt\xF3w",
  ROLLING_12_MONTHS: "W ostatnich 12 miesi\u0105cach",
  RUN_REPORT: "Sporz\u0105d\u017A raport",
  RUSSIAN: "Rosyjski",
  SAP_DOWN_WARNING: "Uszkodzenie funkcji systemu gwarancyjnego. Pracujemy nad jak najszybszym poprawieniem tej sytuacji. Od\u015Bwie\u017C przegl\u0105dark\u0119, aby sprawdzi\u0107 dost\u0119pno\u015B\u0107 systemu.",
  SAVE: "Zapisz",
  SAVE_AS_DRAFT: "Zapisz w wersjach roboczych",
  SAVE_AS_NEW_LAYOUT: "Zapisz jako nowy uk\u0142ad",
  SAVE_AUDIT: "Zapisz audyt",
  SAVE_CHANGES: "Zapisz zmiany",
  SAVE_TO_VALIDATE: "Zapisz, aby zatwierdzi\u0107",
  SAVE_VALD: "Zapisz i zweryfikuj",
  SAVE_VALIDATE: "Zapisz i zweryfikuj",
  SEARCH: "Szukaj",
  SEARCH_BOX_PLACEHOLDER: "Wpisz kod PIN, nr seryjny lub roszczenia, spraw\u0119 DTAC lub nazw\u0119 klienta",
  SEARCH_BY_CLAIM_TYPE: "Wprowad\u017A pe\u0142ne okre\u015Blenie rodzaju roszczenia",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "Roszczenie nale\u017Cy wyszukiwa\u0107, wprowadzaj\u0105c jego pe\u0142n\u0105 nazw\u0119 sk\u0142adaj\u0105c\u0105 si\u0119 z 4\u20139 znak\xF3w",
  SEARCH_BY_FAILURE_PART_NUMBER: "Wprowad\u017A pe\u0142ny numer uszkodzonej cz\u0119\u015Bci",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "Roszczenie nale\u017Cy wyszukiwa\u0107, wprowadzaj\u0105c pe\u0142ny numer uszkodzonej cz\u0119\u015Bci si\u0119 z przynajmniej 4 znaki",
  SEARCH_BY_WORK_ORDER: "Wprowad\u017A nazw\u0119 harmonogramu pracy, przynajmniej 2 znaki",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "Wyszukiwana nazwa harmonogramu pracy musi sk\u0142ada\u0107 si\u0119 z przynajmniej 2 znaki",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "Wpisz pe\u0142ny numer roszczenia",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "Wyszukiwanie roszczenia musi si\u0119 odbywa\u0107 wg pe\u0142nego numeru roszczenia i zawiera\u0107 od 4 do 9 znak\xF3w",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "Wpisz pe\u0142ny numer seryjny komponentu",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "Wyszukiwanie komponentu nale\u017Cy wykona\u0107 za pomoc\u0105 pe\u0142nego numeru seryjnego, przynajmniej 1 znak",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "Wprowad\u017A numer PIN",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "Wpisz pe\u0142ny numer modelu",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "Wyszukiwanie modelu musi uwzgl\u0119dnia\u0107 pe\u0142ny numer modelu zawieraj\u0105cy od 3 do 12 znak\xF3w",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "Wprowad\u017A PIN, przynajmniej 6 znak\xF3w",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "Wyszukiwany PIN musi sk\u0142ada\u0107 si\u0119 z 6\u201317 znak\xF3w",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "Wpisz numer PIP zawieraj\u0105cy minimum 4 znaki",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "Wyszukiwany numer PIP musi zawiera\u0107 od 4 do 12 znak\xF3w",
  SEARCH_RESULTS_TAB: "Wyniki wyszukiwania ({count})",
  SECOND_SHIP_TO_LOCATION: "Miejsce drugiej dostawy",
  SELECT: "Wybierz",
  SELECT_A_RANGE: "Wybierz zakres",
  SELECT_ALL: "Wybierz wszystko",
  SELECT_AUTO_SUBMIT: "Wybierz \u201EAutomatyczne wysy\u0142anie\u201D",
  SELECT_BRANCH: "Wybierz fili\u0119",
  SELECT_CLAIM_TYPE: "Wybierz rodzaj roszczenia",
  SELECT_COLUMNS: "Wybierz Kolumny",
  SELECT_COUNTRY: "Wybierz kraj",
  SELECT_CSV_SEPARATOR: "Wybierz separator CSV",
  SELECT_DATE_FORMAT: "Wybierz format daty",
  SELECT_DEALERS_AND_STATUS: "Wybierz status i dealer\xF3w",
  SELECT_DECIMAL_FORMAT: "Wybierz format dziesi\u0119tny",
  SELECT_DISPLAY_FORMAT: "Wybierz format wy\u015Bwietlania",
  SELECT_FACTORY: "Wybierz fabryk\u0119",
  SELECT_LANGUAGE: "Wybierz j\u0119zyk",
  SELECT_LAYOUT: "Wybierz Uk\u0142ad",
  SELECT_PIP_CODE: "Wybierz kod PIP",
  SELECT_PLAN_NAMES: "Wybierz nazwy plan\xF3w",
  SELECT_SERVICE_INTERVAL_TYPES: "Wybierz rodzaje okien serwisowych",
  SELECT_SORT_BY: "Wybierz Sortuj Wed\u0142ug",
  SELECT_SORT_DIRECTION: "Wybierz Kierunek Sortowania",
  SELECT_STATE: "Wybierz stan",
  SELECT_STATUS: "Wybierz status",
  SELECT_TERRITORY: "Wybierz obszar",
  SELECT_THEME: "Wybierz motyw",
  SELECT_TIME_ZONE: "Wybierz stref\u0119 czasow\u0105",
  SELECT_VALUES_TO_APPROVE: "Wybierz warto\u015Bci, aby zatwierdzi\u0107",
  SELECTED_COLUMNS: "Wybrane Kolumny",
  SELECTED_FOR_AUDIT: "Wybrany dla audytu",
  SELECTED_FOR_AUDIT_VSR: "Patrz rozwi\u0105zanie DTAC 221475 w celu uzyskania wymaganej dokumentacji audytu i za\u0142\u0105cznik\xF3w potrzebnych do tej reklamacji",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "Wyb\xF3r wielu kont i rodzaj\xF3w gwarancji wp\u0142ywa na wydajno\u015B\u0107",
  SEND: "Wy\u015Blij",
  SERIAL_NUMBER: "Numer seryjny",
  SERIAL_NUMBER_INVOICE_NUMBER: "Numer seryjny / Numer faktury",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "Wniosek anulowano ze wzgl\u0119du na zbyt d\u0142ugie oczekiwanie na odpowied\u017A serwera. Postaraj si\u0119 sformu\u0142owa\u0107 bardziej konkretny wniosek lub spr\xF3buj ponownie p\xF3\u017Aniej.",
  SERVICE_DATE_IS_REQUIRED: "Wymagane s\u0105 dane dotycz\u0105ce obs\u0142ugi",
  SERVICE_INTERVAL: "Okres mi\u0119dzyserwisowy",
  SERVICE_INTERVAL_BEGIN_DATE: "Data rozpocz\u0119cia okna serwisowego",
  SERVICE_INTERVAL_END_DATE: "Data zako\u0144czenia okna serwisowego",
  SERVICE_INTERVAL_IS_REQUIRED: "Wymagane jest podanie czasu pracy mi\u0119dzy przegl\u0105dami",
  SERVICE_INTERVAL_NUMBER: "Numer przerwy serwisowej",
  SERVICE_INTERVAL_STATUS: "Stan przerwy serwisowej",
  SERVICE_INTERVAL_TYPE: "Rodzaj okresu mi\u0119dzyserwisowego",
  SERVICE_INTERVAL_TYPES: "Rodzaje okien serwisowych",
  SERVICE_PART: "Cz\u0119\u015B\u0107 serwisowa",
  SERVICE_UNAVAILABLE: "Us\u0142uga niedost\u0119pna",
  SERVICED: "Serwisowano",
  SERVICED_DATE_IS_REQUIRED: "Wymagana jest data us\u0142ugi.",
  SERVICED_IS_REQUIRED: "Wymagane jest serwisowanie.",
  SET_AS_DEFAULT: "Ustaw jako domy\u015Blne",
  SETTINGS: "Moje ustawienia",
  SETTLED: "Zako\u0144czony",
  SETTLEMENT_NO_REGISTRATION: "Zako\u0144czono \u2014 brak rejestracji",
  SETUP: "Konfiguracja",
  SETUP_DATE_IS_REQUIRED: "Wymagane jest podanie daty konfiguracji",
  SETUP_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola \u201EKonfiguracja\u201D",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "Wy\u015Blij do",
  SHIPPED: "Dostarczono",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "Informacje o wysy\u0142ce/instrukcje specjalne",
  SHIPPING_INSTRUCTIONS: "Instrukcje dostawy",
  SHORT_TEXT: "Kr\xF3tki tekst",
  SHORT_TEXT_IS_REQUIRED: "Kr\xF3tki tekst jest wymagany",
  SHOW_ALL: "Poka\u017C wszystko ({count})",
  SHOW_EXCLUDED: "Poka\u017C wykluczone",
  SHOW_MORE: "Poka\u017C wi\u0119cej",
  SHOW_MORE_GROUPS: "Poka\u017C wi\u0119cej grup ({countToDisplay})",
  SHOW_RED_IF_LESS_THAN: "Wy\u015Bwietl na czerwono, je\u015Bli mniej ni\u017C",
  SHOW_REIMBURSED_AMOUNT: "Wy\u015Bwietl zwr\xF3con\u0105 kwot\u0119",
  SHOW_REIMBURSED_PERCENTAGE: "Wy\u015Bwietl zwr\xF3con\u0105 kwot\u0119 (w procentach)",
  SHOW_YELLOW_IF_LESS_THAN: "Wy\u015Bwietl na \u017C\xF3\u0142to, je\u015Bli mniej ni\u017C",
  SIGN_IN_REQUIRED: "Wymagane logowanie",
  SIGN_OUT: "Wyloguj si\u0119",
  SKIP_AUDIT: "Pomi\u0144 audyt",
  SKIP_AUDIT_SUCCESS: "Audyt zosta\u0142 pomini\u0119ty, a termin jest teraz w przysz\u0142o\u015Bci.",
  SOME_PARTS_RETURNED: "Zwr\xF3cono niekt\xF3re cz\u0119\u015Bci",
  SORT_BY: "Sortuj wed\u0142ug",
  SPANISH: "Hiszpa\u0144ski",
  SPECIAL_ALLOWANCE: "SPECJALNE POZWOLENIE",
  SPECIAL_ALLOWANCE_CALCULATION: "Specjalna kalkulacja przydzia\u0142u",
  SPECIAL_ALLOWANCE_CLAIM: "Roszczenie dotycz\u0105ce specjalnego pozwolenia",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "Status roszczenia dotycz\u0105cego przydzia\u0142u specjalnego",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "Status roszczenia dotycz\u0105cego przydzia\u0142u specjalnego",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "Status roszczenia dotycz\u0105cego przydzia\u0142u specjalnego zaktualizowany",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "Numer roszczenia dotycz\u0105cego przydzia\u0142u specjalnego \u2014 {claimNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "Roszczenia dotycz\u0105ce przydzia\u0142u specjalnego ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "Wk\u0142ad przydzia\u0142u specjalnego",
  SPECIAL_ALLOWANCE_DESCRIPTION: "Opis przydzia\u0142u specjalnego",
  SPECIAL_ALLOWANCE_TYPE: "Typ roszczenia specjalnego",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "Wymagane jest podanie rodzaju przydzia\u0142u specjalnego",
  SPECIAL_INSTRUCTIONS: "Instrukcje specjalne",
  SPG: "SPG",
  SPGS: "Cennik us\u0142ug serwisowych (SPG)",
  STANDARD_VIEW: "Og\xF3lna perspektywa",
  START_AMOUNT_OF_USE: "Pocz\u0105tkowy stopie\u0144 wykorzystania",
  STARTS: "Pocz\u0105tek",
  STARTS_WITH: "Zaczyn\u0105 si\u0119 z",
  STATE: "Wojew\xF3dztwo",
  STATE_PROVINCE: "Wojew\xF3dztwo",
  STATE_PROVINCE_REQUIRED: "Wymagane wojew\xF3dztwo",
  STATUS: "Status",
  STATUS_CHANGE_REQUEST: "Wniosek o zmian\u0119 statusu",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "Pomy\u015Blnie utworzono wniosek o zmian\u0119 statusu",
  STATUS_FOR: "Status elementu {pin}",
  STATUS_INDICATOR: "Wska\u017Anik statusu",
  STATUS_REASON: "Status przyczyny",
  STOLEN_DATE: "Data kradzie\u017Cy",
  STORE: "Sklep",
  STORE_IS_REQUIRED: "Wymagane jest wype\u0142nienie pola \u201ESklep\u201D",
  STORE_NUMBER_IS_REQUIRED: "Wymagany jest numer sklepu",
  STREET_1: "Ulica 1",
  STREET_2: "Ulica 2",
  SUB: "Wy\u015Blij",
  SUB_CLAIM_TYPE: "Rodzaj reklamacji drugorz\u0119dnej",
  SUB_TYPE: "Podtyp",
  SUBMISSION_DATE: "Data wys\u0142ania",
  SUBMIT: "Wy\u015Blij",
  SUBMIT_AUDIT: "Wy\u015Blij audyt",
  SUBMIT_AUDIT_FOR: "Wy\u015Blij audyt dla u\u017Cytkownika {dealer}",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Wy\u015Blij pe\u0142ne obci\u0105\u017Cenie roszczenia {claimNumber}",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Wy\u015Blij cz\u0119\u015Bciowe obci\u0105\u017Cenie roszczenia {claimNumber}",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Wy\u015Blij procent roszczenia obci\u0105\u017Cenia dla {claimNumber}",
  SUBMIT_REQUEST: "Prze\u015Blij wniosek",
  SUBMITTED: "WYS\u0141ANO",
  SUBMITTED_AVAILABLE_TO_EDIT: "WYS\u0141ANO (Edytowalne)",
  SUCCESS: "Sukces",
  SUCCESS_MESSAGE_TITLE: "Pomy\u015Blnie zako\u0144czono operacj\u0119",
  SUCCESS_MESSAGES_TITLE: "Pomy\u015Blnie zako\u0144czono operacje",
  SUPPLIER_WARRANTY: "Gwarancja dostawcy",
  SURVEY_QUESTIONS: "Pytania ankietowe",
  SUSPENDED: "Zawieszony",
  SWEDISH: "Szwedzki",
  SYSTEM_SELECTED_CLAIMS: "Roszczenia wybrane przez system",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "Roszczenia wybrane przez system ({count})",
  TABM: "TABM",
  TAX: "Podatek",
  TCSM: "TCSM",
  TECH_ID: "ID techn.",
  TERMINATED: "Zako\u0144czony",
  TERMINATES: "Data zako\u0144czenia",
  TERRITORY: "Obszar",
  TEST: "Test",
  TEST_RESULTS_CODE: "Kod wynik\xF3w test\xF3w",
  THEME: "Motyw",
  TIME_LIMIT: "Limit czasu",
  TIME_ZONE: "Strefa czasowa",
  TITLE: "Tytu\u0142",
  TITLE_IS_REQUIRED: "Tytu\u0142 jest wymagany",
  TO: "Do",
  TODAY: "Dzisiaj",
  TOO_MANY_RESULTS: "Twoje \u017C\u0105danie zwr\xF3ci\u0142o zbyt wiele wynik\xF3w. Zaw\u0119\u017A wyszukiwane terminy i spr\xF3buj ponownie.",
  TOTAL: "Razem",
  TOTAL_AMOUNT: "Ca\u0142kowita ilo\u015B\u0107",
  TOTAL_APPROVED: "\u0141\u0105cznie zatwierdzonych",
  TOTAL_APPROVED_CLAIM_VALUE: "Ca\u0142kowita warto\u015B\u0107 zaakceptowanych roszcze\u0144",
  TOTAL_APPROVED_INCLUDING_TAXES: "Wszystkie zaakceptowane z podatkami",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "\u0141\u0105czna liczba wszystkich zatwierdzonych roszcze\u0144 bez dodatk\xF3w",
  TOTAL_CONTRIBUTION: "Ca\u0142kowity wk\u0142ad",
  TOTAL_REIMBURSED: "Ca\u0142kowita kwota zwrotu",
  TOTAL_REIMBURSED_WITH_CURRENCY: "Ca\u0142kowita wysoko\u015B\u0107 zwr\xF3conej kwoty ({currency})",
  TOTAL_REQUESTED: "\u0141\u0105cznie zg\u0142oszonych",
  TOTAL_REQUESTED_CLAIM_VALUE: "Ca\u0142kowita warto\u015B\u0107 wnioskowanych roszcze\u0144",
  TOTAL_UNPAID: "Nieop\u0142acone, \u0142\u0105cznie",
  TRACKING_NUMBER: "Numer \u015Bledzenia",
  TRANSFER: "Transfer",
  TRANSFER_APPROVALS: "Zatwierdzenia transfer\xF3w",
  TRANSFER_APPROVALS_TAB: "Zatwierdzenia transfer\xF3w ({count})",
  TRANSFER_CREATED: "Utworzono transfer",
  TRANSFER_DEALER_RECOMMENDATIONS: "Czy na pewno chcesz przenie\u015B\u0107 numer PIN do innego dealera?",
  TRANSFER_UPDATED_SUCCESSFULLY: "Pomy\u015Blnie zaktualizowano transfer",
  TRANSFERS: "Transfery",
  TRAVEL: "Podr\xF3\u017C",
  TURKISH: "Turecki",
  TWO_PERCENT_WITHHOLD_VALUE: "2% warto\u015Bci potr\u0105ca\u0107",
  TYPE: "Rodzaj",
  TYPES: "Rodzaje",
  UNABLE_TO_CONTACT_THE_SERVER: "Brak po\u0142\u0105czenia z serwerem",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "Nie mo\u017Cna wczyta\u0107 szczeg\xF3\u0142\xF3w klienta",
  UNDO: "Cofnij",
  UNDO_REGISTRATION: "Cofnij rejestracj\u0119",
  UNDO_REGISTRATION_SUCCESSFULL: "Cofni\u0119cie rejestracji zako\u0144czone powodzeniem",
  UNIT: "Jednostka",
  UNIT_1: "Jednostka 1",
  UNIT_2: "Jednostka 2",
  UNIT_3: "Jednostka 3",
  UNIT_OF_MEASURE: "Jednostka miary",
  UNPAID_LABOR: "Nieop\u0142acone prace",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "Niep\u0142atne dodatki pracownicze \u2014 z wy\u0142\u0105czeniem programu poprawy produktu (PIP)",
  UNPAID_LABOR_ADDITIVES_PIPS: "Niep\u0142atne dodatki pracownicze \u2014 PIP",
  UNPAID_OTHER_CREDITS: "Inne niezap\u0142acone kwoty",
  UNPAID_PARTS: "Nieop\u0142acone cz\u0119\u015Bci",
  UNPAID_PARTS_ADDITIVE: "Niezap\u0142acony dodatek do cz\u0119\u015Bci",
  UNPAID_TRAVEL: "Niezap\u0142acone koszty podr\xF3\u017Cy",
  UNSUB: "Edytuj",
  UNSUBMIT_CLAIM: "Edytuj Reklamacja",
  UPDATE_CUSTOMER_INFORMATION: "Aktualizuj informacje o kliencie",
  UPDATE_LABOR_RATES: "Aktualizacja stawki roboczej",
  UPDATE_LAYOUT: "Aktualizacja Uk\u0142ad",
  UPDATE_MACHINE_STATUS: "Aktualizuj stan urz\u0105dzenia",
  UPDATE_MACHINE_STATUS_HISTORY: "Historia aktualizacji statusu urz\u0105dzenia",
  UPDATE_REGISTRATION: "Aktualizuj rejestracj\u0119",
  UPDATE_SELECTED: "Aktualizuj wybrane",
  UPDATED: "Zaktualizowano",
  UPDATED_BY: "Aktualizowany przez",
  UPLOAD_DOCUMENT: "Przeka\u017C dokument",
  UPTIME_ASSURANCE: "Zapewnienie czasu pracy",
  USEFUL_LINKS: "Przydatne linki",
  USER: "u\u017Cytkownika",
  USER_PREFERENCES_UPDATED: "Zaktualizowano preferencje u\u017Cytkownika",
  USER_SELECTED: "Wybrane przez u\u017Cytkownika",
  USER_SELECTED_CLAIMS_WITH_COUNT: "Roszczenia wybrane przez u\u017Cytkownika ({count})",
  USERS_INFORMATION: "Informacje o u\u017Cytkownikach",
  VALIDATE: "Zatwierd\u017A",
  VALIDATE_CLAIM: "Weryfikuj roszczenie",
  VALUE: "Warto\u015B\u0107",
  VALUE_OF_REPAIR: "Warto\u015B\u0107 naprawy",
  VIEW_CLAIM: "Zobacz roszczenie",
  VIEW_DETAILS: "Wy\u015Bwietl szczeg\xF3\u0142y",
  VIEW_OPEN_PIPS: "Wy\u015Bwietl otwarte programy PIP",
  VIEW_PIP: "Wy\u015Bwietl PIP",
  VIEW_PRODUCTS: "Wy\u015Bwietl produkty",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "Poka\u017C produkty & Uaktualnij informacje",
  VIEW_UPDATE: "Zobacz/Aktualizuj",
  VSR_MESSAGES: "Wiadomo\u015Bci VSR",
  WAITING_FOR_DLR_INV: "Oczekiwanie na faktur\u0119 dla sprzedawcy",
  WAITING_FOR_INVOICE: "Oczekiwanie na faktur\u0119 ({count})",
  WAITING_SINCE: "Oczekiwanie trwa od",
  WARNING_MESSAGE_TITLE: "Wys\u0142ano ostrze\u017Cenie",
  WARNING_MESSAGES: "Komunikaty ostrzegawcze",
  WARNING_MESSAGES_TITLE: "Wys\u0142ano ostrze\u017Cenia",
  WARRANTY: "Gwarancja",
  WARRANTY_ADMIN: "Administrator Gwarancja",
  WARRANTY_CLAIM_TYPE: "Rodzaj reklamacji gwarancyjnej",
  WARRANTY_COVERAGE: "Okres gwarancyjny",
  WARRANTY_EXPIRATION: "Wyga\u015Bni\u0119cie gwarancji",
  WARRANTY_TYPE: "Rodzaj gwarancji",
  WARRANTY_TYPES: "Rodzaje gwarancji",
  WEAR_PARTS: "Noszenie cz\u0119\u015Bci",
  WEAR_PARTS_COVERAGE: "Zakres zu\u017Cycia cz\u0119\u015Bci",
  WELCOME: "Witamy",
  WIP: "Praca w toku",
  WITH_ADDITIVES: "Z dodatkami",
  WITNESS_FIRST_NAME: "Imi\u0119 \u015Bwiadka",
  WITNESS_LAST_NAME: "Nazwisko \u015Bwiadka",
  WORK_ORDER: "Harmonogram pracy",
  WORK_ORDER_NUMBER: "Numer harmonogramu pracy",
  WORK_ORDER_ONE: "Harmonogram pracy 1",
  WORK_ORDER_ONE_IS_REQUIRED: "Wymagane jest podanie harmonogramu pracy nr 1",
  WORK_ORDER_THREE: "Harmonogram pracy 3",
  WORK_ORDER_THREE_IS_REQUIRED: "Wymagane jest podanie harmonogramu pracy nr 3",
  WORK_ORDER_TWO: "Harmonogram pracy 2",
  WORK_REPAIR_ORDER: "Harmonogram prac naprawczych",
  YES: "TAK",
  YES_LOWERCASE: "Tak"
});